<template>
    <div class="agenda h-100 mh-100">
        <b-container class="d-flex flex-column h-100 mh-100">
            <div class="d-flex flex-column h-100 mh-100" v-show="agendas.length > 0">
                <div class="main-header">
                    <b-row class="align-items-center">
                        <b-col cols="12" xl="6" class="d-flex align-content-center mb-3 mb-xl-0 justify-content-center justify-content-xl-start">
                            <b-button-group size="sm" class="float-left order-1 order-md-0">
                                <b-button @click="previousWeek" variant="primary"><i class="fas fa-angle-left"></i></b-button>
                                <b-button @click="nextWeek" variant="primary"><i class="fas fa-angle-right"></i></b-button>
                                <b-button @click="today" variant="primary">Hoje</b-button>
                            </b-button-group>
                            <date-range-picker
                              class="order-0 order-md-1"
                              ref="pickerAgenda"
                              :localeData="dateRangePickerPtBrLocale"
                              :singleDatePicker="true"
                              :timePicker="false"
                              :timePicker24Hour="false"
                              :showDropdowns="true"
                              :ranges="false"
                              :showWeekNumbers="false"
                              :selectWeek="(currentView == 'week')"
                              :opens="'right'"
                              @update="dateRangePickerAgendaUpdated"
                              @changeMonth="dateRangePickerAgendaMonthChanged"
                              @toggle="dateRangePickerAgendaToggle"
                              :datesClasses="dateRangePickerDatesClasses"
                              :clickableAreaClass="($attrs['isMobile'])?'title mr-4':'title ml-4'"
                              :minDate="agendaConfig.minDate"
                              :maxDate="agendaConfig.maxDate"
                              v-model="currentRange">
                                <div slot="input" class="pointer d-flex align-content-center">
                                    <span><i class="far fa-sm fa-calendar-alt mr-1"></i> {{ currentLabel }}</span>
                                </div>
                            </date-range-picker>
                        </b-col>
                        <b-col cols="12" xl="6">
                            <b-row class="d-flex align-items-center" :class="{ 'justify-content-end': !$attrs['isMobile'] }">
                                <b-col>
                                    <multiselect v-model="agenda" :options="agendas" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :allow-empty="false" :searchable="false" placeholder="Selecione uma Agenda" @select="agendaSelected"></multiselect>
                                </b-col>
                                <b-col cols="auto" v-if="!$attrs['isMobile']">
                                    <b-button-group size="sm">
    <!--                                    <b-button @click="changeView('month')" :variant="currentView == 'month'?'primary':''">Mês</b-button>-->
                                        <b-button @click="changeView('week')" :variant="currentView == 'week'?'primary':''">Semana</b-button>
                                        <b-button @click="changeView('day')" :variant="currentView == 'day'?'primary':''">Dia</b-button>
<!--                                        <b-button @click="changeView('list')" :variant="currentView == 'list'?'primary':''">Lista</b-button>-->
                                    </b-button-group>
                                </b-col>
                                <b-col cols="auto" v-if="agenda != null && agenda.can_manage">
                                    <b-button-group size="sm">
                                        <b-button @click="print()" variant="primary"><i class="far fa-print"></i></b-button>
                                        <b-button v-b-modal.appointment-modal variant="success"><i class="far fa-plus"></i></b-button>
                                    </b-button-group>
                                </b-col>
                            </b-row>
                        </b-col>
                    </b-row>
                    <hr class="mb-0">
                    <b-row>
                      <b-col>
                        <b-alert v-if="this.helpers.planHasPermission('telehealth') && telehealthAvailableMinutes != null && telehealthAvailableMinutes <= 2*60" show :variant="telehealthAvailableMinutes > 0 ? 'warning' : 'danger'" class="mb-0 p-2 text-center telehealth-minutes-warning">
                            <p class="mb-0">
                              <template v-if="telehealthAvailableMinutes > 0">
                                Seus minutos de teleconsulta estão acabando. Recomendamos que contrate mais minutos para evitar que as próximas teleconsultas sejam bloqueadas.
                              </template>
                              <template v-else>
                                Seus minutos de teleconsulta acabaram. Você pode contratar mais minutos ou aguardar a renovação da sua assinatura para desbloquear as teleconsultas.
                              </template>
                              {{(this.helpers.isOwner() || this.helpers.checkPermission('subscription', 'can_manage')) ? '' : ' Fale com o gestor do seu consultório.'}}
                              <router-link v-if="this.helpers.isOwner() || this.helpers.checkPermission('subscription', 'can_manage')" target="_blank" tag="a" :to="'/minha-assinatura'">Ajustar assinatura</router-link>
                            </p>
                        </b-alert>
                      </b-col>
                    </b-row>
                </div>
                <div class="box-fullcalendar">
                    <div :class="{ 'eventSelected': eventSelected != null }">
                        <FullCalendar ref="agenda"
                                      v-show="currentView != 'list'"
                                      :defaultView="($attrs['isMobile'])?'timeGridDay':'timeGridWeek'"
                                      locale="pt-br"
                                      :first-day="firstDay"
                                      :now-indicator="true"
                                      :plugins="calendarPlugins"
                                      :all-day-slot="false"
                                      :content-height="'auto'"
                                      :slot-duration="agendaConfig.slotDuration"
                                      :min-time="agendaConfig.minTime"
                                      :max-time="agendaConfig.maxTime"
                                      :column-header-format="{ weekday: 'long', month: 'numeric', day: 'numeric', omitCommas: true }"
                                      :slot-label-interval="agendaConfig.slotDuration"
                                      :slot-label-format="{ hour: 'numeric', minute: '2-digit', omitZeroMinute: false }"
                                      :header="{ left: '', center: '', right: '' }"
                                      :button-text="{
                                        today: 'hoje',
                                        month: 'mês',
                                        week: 'semana',
                                        day: 'dia',
                                        list: 'lista'
                                      }"
                                      :column-header-html="columnHeaderHtml"
                                      :events="calendarEvents"
                                      @dateClick="handleDateClick"
                                      @eventClick="handleEventClick"
                                      @eventDrop="handleEventDrop"
                                      :eventRender="handleEventRender"
                                      :nav-links="true"
                                      :nav-link-day-click="selectDay"
                                      :event-limit="3"
                                      :event-limit-text="(n) => { return '+'+n; }"
                        />
                        <div v-show="currentView == 'list'">
                            <table class="table table-striped table-responsive table-hover table-bordered" style="display: table; margin-top: 20px; margin-bottom: 0;">
                                <thead>
                                    <tr class="thead">
                                        <th>Data / Hora</th>
                                        <th>Paciente</th>
                                        <th>Telefone</th>
                                        <th>Profissional</th>
                                        <th>Tipo de Agendamento</th>
                                        <th>Convênio</th>
                                        <th>Status</th>
                                    </tr>
                                </thead>
                                <tbody v-if="calendarEvents.filter(event => typeof event.appointment != 'undefined' && event.appointment.type == 'APPOINTMENT').length > 0">
                                    <template v-for="event in calendarEvents.filter(event => typeof event.appointment != 'undefined' && event.appointment.type == 'APPOINTMENT')">
                                        <tr :key="event.id">
                                            <td :rowspan="(event.appointment.notes != null && event.appointment.notes != '')?2:1" class="text-nowrap">{{ moment(event.start).format('DD/MM HH:mm') }}</td>
                                            <td>{{ event.appointment.patient.name }} <small>{{ (event.appointment.patient.internal_code != null && event.appointment.patient.internal_code != '')?'('+event.appointment.patient.internal_code+')':'' }}</small></td>
                                            <td class="text-nowrap">{{ (event.appointment.patient.cellphone != '')?event.appointment.patient.cellphone:event.appointment.patient.telephone }}</td>
                                            <td>{{ event.appointment.professional.name }}</td>
                                            <td>{{ event.appointment.appointment_type.type }} - {{ event.appointment.appointment_format.format }}</td>
                                            <td>{{ event.appointment.health_plan.name }}</td>
                                            <td>{{ getStatusName(event.appointment.status) }}</td>
                                        </tr>
                                        <tr :key="event.id" v-if="(event.appointment.notes != null && event.appointment.notes != '')">
                                            <td colspan="7"><small>Observações: {{ event.appointment.notes }}</small></td>
                                        </tr>
                                    </template>
                                </tbody>
                                <tbody v-else>
                                    <tr>
                                        <td colspan="7" class="text-center">
                                            <h4 class="text-center">Sem agendamentos {{ (currentView == 'day')?'nesta data':'neste período' }}!</h4>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                <div class="printable" v-if="calendarEvents.length > 0">
                    <table class="table table-striped table-responsive table-hover table-bordered m-0">
                        <thead>
                            <tr>
                                <th colspan="8">
                                    <h3 class="text-center">{{ agenda.name }}</h3>
                                    <h4 class="text-center">{{ currentLabel }}{{ (currentView == 'week')?moment(currentDate).format(' [de] YYYY'):''}}</h4>
                                    <h5 class="text-center">Impresso em <b>{{ moment().format('DD/MM/YYYY HH:mm')}}</b> por <b>{{ user.name }}</b></h5>
                                </th>
                            </tr>
                            <tr class="thead">
                                <th>Data / Hora</th>
                                <th>Paciente</th>
                                <th>Telefone</th>
                                <th>Data de nascimento</th>
                                <th>Profissional</th>
                                <th>Tipo de Agendamento</th>
                                <th>Convênio</th>
                                <th>Status</th>
                            </tr>
                        </thead>
                        <tbody v-if="calendarEvents.filter(event => typeof event.appointment != 'undefined' && event.appointment.type == 'APPOINTMENT').length > 0">
                            <template v-for="event in calendarEvents.filter(event => typeof event.appointment != 'undefined' && event.appointment.type == 'APPOINTMENT')">
                                <tr :key="event.id">
                                    <td :rowspan="(event.appointment.notes != null && event.appointment.notes != '')?2:1" class="text-nowrap">{{ moment(event.start).format('DD/MM HH:mm') }}</td>
                                    <td>{{ event.appointment.patient.name }} <small>{{ (event.appointment.patient.internal_code != null && event.appointment.patient.internal_code != '')?'('+event.appointment.patient.internal_code+')':'' }}</small></td>
                                    <td class="text-nowrap">{{ (event.appointment.patient.cellphone != '')?event.appointment.patient.cellphone:event.appointment.patient.telephone }}</td>
                                    <td>{{ event.appointment.patient.birthday != null ? moment(event.appointment.patient.birthday).format('DD/MM/YYYY') : '' }}</td>
                                    <td>{{ event.appointment.professional.name }}</td>
                                    <td>{{ event.appointment.appointment_type.type }} - {{ event.appointment.appointment_format.format }}</td>
                                    <td>{{ event.appointment.health_plan.name }}</td>
                                    <td>{{ getStatusName(event.appointment.status) }}</td>
                                </tr>
                                <tr :key="event.id" v-if="(event.appointment.notes != null && event.appointment.notes != '')">
                                    <td colspan="7">{{ event.appointment.notes }}</td>
                                </tr>
                            </template>
                        </tbody>
                        <tbody v-else>
                            <tr>
                                <td colspan="8" class="text-center">
                                    <h4 class="text-center">Sem agendamentos {{ (currentView == 'day')?'nesta data':'neste período' }}!</h4>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
            <div class="main-content-cj" v-show="agendas.length == 0">
                <div class="box-container">
                    <b-row class="mb-3">
                        <b-col cols="12">
                            <div class="box-cj">
                                <div class="content text-center">
                                    <h3>Você não possui permissão para visualizar nenhuma agenda!</h3>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                </div>
            </div>
        </b-container>

        <b-modal size="lg" id="appointment-modal" class="appointment-modal" :modalClass="'appointment-modal'" @hidden="resetAppointmentModal">
            <template slot="modal-header">
                <div class="w-100 text-center">
                    {{ appointmentForm.type }}<br/>
                    {{ buildModalHeader() }}
                </div>
            </template>
            <template slot="default">
                <validation-observer ref="appointmentForm" v-slot="{ invalid }">
                    <b-container>
                        <b-row class="mb-2">
                            <b-col>
                                <label class="cj-label">Agendamento ou Bloqueio</label>
                                <multiselect v-model="appointmentForm.type" :options="typeOptions" :showLabels="false" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" :allowEmpty="false" placeholder="Selecione um Tipo"></multiselect>
                            </b-col>
                        </b-row>
                        <div v-if="appointmentForm.type == 'Agendamento'">
                            <b-row class="mb-2">
                                <b-col md="4" cols="12">
                                    <label class="cj-label">Data do Agendamento</label>
                                    <date-range-picker
                                      class="w-100"
                                      ref="picker"
                                      :localeData="dateRangePickerPtBrLocale"
                                      :minDate="(appointmentForm.id == null)?moment().add(1, 'days').format('YYYY-MM-DD'):null"
                                      :singleDatePicker="true"
                                      :timePicker="false"
                                      :timePicker24Hour="false"
                                      :showDropdowns="true"
                                      :ranges="false"
                                      :showWeekNumbers="false"
                                      :selectWeek="false"
                                      v-model="appointmentForm.dateTime">
                                        <div slot="input" slot-scope="picker" class="">
                                            {{ moment(picker.startDate).format('DD/MM/YYYY') }}
                                        </div>
                                    </date-range-picker>
                                </b-col>
                                <b-col md="4" cols="6" class="mt-2 mt-md-0">
                                    <label class="cj-label">Horário de Início</label>
                                    <validation-provider name="horário de início" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                                        <b-input-group class="time-group">
                                            <b-button-group size="sm">
                                                <b-button @click="changeTime('startTime', 'subtract', 5, 'minutes')" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" variant="primary"><i class="far fa-minus-circle"></i></b-button>
                                            </b-button-group>
                                            <b-form-input type="tel" :value="(appointmentForm.startTime instanceof moment)?appointmentForm.startTime.format('HH:mm'):appointmentForm.startTime" v-mask="'##:##'" @input="updateStartTime" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                                            <b-button-group size="sm">
                                                <b-button @click="changeTime('startTime', 'add', 5, 'minutes')" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" variant="primary"><i class="far fa-plus-circle"></i></b-button>
                                            </b-button-group>
                                        </b-input-group>
                                        <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-col>
                                <b-col md="4" cols="6" class="mt-2 mt-md-0">
                                    <label class="cj-label">Horário de Término</label>
                                    <validation-provider name="horário de término" :rules="{ required: true, regex: '^(0[0-9]|1[0-9]|2[0-3]|[0-9]):[0-5][0-9]$' }" v-slot="{ errors }">
                                        <b-input-group class="time-group">
                                            <b-button-group size="sm">
                                                <b-button @click="changeTime('endTime', 'subtract', 5, 'minutes')" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" variant="primary"><i class="far fa-minus-circle"></i></b-button>
                                            </b-button-group>
                                            <b-form-input type="tel" :value="(appointmentForm.endTime instanceof moment)?appointmentForm.endTime.format('HH:mm'):appointmentForm.endTime" v-mask="'##:##'" @input="updateEndTime" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                                            <b-button-group size="sm">
                                                <b-button @click="changeTime('endTime', 'add', 5, 'minutes')" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" variant="primary"><i class="far fa-plus-circle"></i></b-button>
                                            </b-button-group>
                                        </b-input-group>
                                        <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-col>
                            </b-row>
                            <b-col class="pb-2 mb-2 repeat-box" v-if="appointmentForm.id == null">
                                <b-row class="mb-2">
                                    <b-col>
                                        <label class="cj-label">Repetir agendamento</label>
                                        <multiselect v-model="repeatForm.enabled" :options="repeatTypes" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :searchable="false"  placeholder="Selecione"></multiselect>
                                    </b-col>
                                    <template v-if="repeatForm.enabled && repeatForm.enabled.value">
                                        <b-col>
                                            <label class="cj-label">Repetir a cada</label>
                                            <validation-provider name="intervalo" :rules="{ required: true, min: 1 }" v-slot="{ errors }">
                                                <b-form-input v-model="repeatForm.interval" type="number" min="1" step="1" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                                                <span class="cj-error">{{ errors[0] }}</span>
                                            </validation-provider>
                                        </b-col>
                                        <b-col>
                                            <label class="cj-label">&nbsp;</label>
                                            <multiselect v-model="repeatForm.option" :options="repeatOptions" track-by="name" label="name" @select="repeatTypeSelected" :preselectFirst="true" :showLabels="false" :searchable="false" placeholder="Selecione"></multiselect>
                                        </b-col>
                                    </template>
                                </b-row>
                                <b-row class="mb-2" v-if="repeatForm.enabled && repeatForm.option && repeatForm.option.value == 'week'">
                                    <b-col>
                                        <ul class="days-of-week">
                                            <li v-for="dow in [0, 1, 2, 3, 4, 5, 6]" :key="dow" @click="toggleDow(dow)" :class="{ 'enabled': repeatForm.daysOfWeek.includes(dow) }">{{ moment().weekday(dow).format('ddd') }}</li>
                                        </ul>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2" v-if="repeatForm.enabled && repeatForm.option && repeatForm.option.value == 'month'">
                                    <b-col>
                                        <multiselect v-model="repeatForm.month" :options="repeatMonthOptions" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :searchable="false" placeholder="Selecione"></multiselect>
                                    </b-col>
                                </b-row>
                                <b-row v-if="repeatForm.enabled && repeatForm.enabled.value">
                                    <b-col>
                                        <label class="cj-label">Termina em</label>
                                        <multiselect v-model="repeatForm.end" :options="endedOptions" track-by="name" label="name" :preselectFirst="true" :showLabels="false" :searchable="false" placeholder="Selecione"></multiselect>
                                    </b-col>
                                    <b-col v-if="repeatForm.end && repeatForm.end.value == 'specific-date'">
                                        <label class="cj-label">Data de término</label>
                                        <validation-provider name="data de término" :rules="{ required: (repeatForm.end.value == 'specific-date') }" v-slot="{ errors }">
                                            <date-picker name="date" v-model="repeatForm.endValue" v-mask="'##/##/####'" :config="datePickerOptions" :class="{ 'error': errors.length > 0 }"></date-picker>
                                            <span class="cj-error">{{ errors[0] }}</span>
                                        </validation-provider>
                                    </b-col>
                                    <b-col v-if="repeatForm.end && repeatForm.end.value == 'repeats'">
                                        <label class="cj-label">Após n ocorrências</label>
                                        <validation-provider name="quantidade de ocorrências" :rules="{ required: (repeatForm.end.value == 'repeats') }" v-slot="{ errors }">
                                            <b-form-input v-model="repeatForm.endValue" type="number" min="1" step="1" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                                            <span class="cj-error">{{ errors[0] }}</span>
                                        </validation-provider>
                                    </b-col>
                                </b-row>
                            </b-col>
                            <b-row class="mb-2">
                              <b-col>
                                  <label class="cj-label">Tipo de Agendamento</label>
                                  <validation-provider name="tipo de agendamento" :rules="{ required: true }" v-slot="{ errors }">
                                      <multiselect v-model="appointmentForm.appointmentType"  :options="appointmentTypes" track-by="name" label="name" :preselectFirst="true" :allowEmpty="false" :showLabels="false" :searchable="false" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" placeholder="Selecione um Tipo de Agendamento" :class="{ 'error': errors.length > 0 }"></multiselect>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                  </validation-provider>
                              </b-col>
                              <b-col>
                                  <label class="cj-label">Formato</label>
                                  <validation-provider name="formato" :rules="{ required: true }" v-slot="{ errors }">
                                      <multiselect v-model="appointmentForm.appointmentFormat"  :options="appointmentFormats" track-by="name" label="name" :preselectFirst="true" :allowEmpty="false" :showLabels="false" :searchable="false" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" placeholder="Selecione um Formato de Agendamento" :class="{ 'error': errors.length > 0 }"></multiselect>
                                      <span class="cj-error">{{ errors[0] }}</span>
                                  </validation-provider>
                              </b-col>
                              <b-col>
                                <label class="cj-label d-block">&nbsp;</label>
                                <div v-if="appointmentForm.appointmentFormat != null && appointmentForm.appointmentFormat.name == 'Online'" class="pretty p-switch p-fill">
                                  <input type="checkbox" v-model="appointmentForm.send_telehealth_link" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" />
                                  <div class="state p-success">
                                    <label><span>Enviar lembrete e link da teleconsulta</span></label>
                                  </div>
                                </div>
                              </b-col>
                            </b-row>

                            <b-row v-if="appointmentForm.send_telehealth_link && appointmentForm.telehealth_attendance != null">
                              <b-col>
                                <b-alert show variant="success" class="telehealth-info mb-2 text-center">
                                  <p class="mb-1">Link do paciente: {{aolUrl + 'teleconsulta/' + appointmentForm.telehealth_attendance.id}}</p>
                                  <p class="mb-2">Código de acesso: {{appointmentForm.telehealth_attendance.code}}</p>
                                  <b-button size="sm" variant="primary" @click="sendTelehealthWhatsapp">Enviar Whatsapp <i class="fab fa-whatsapp"></i></b-button>
                                </b-alert>
                              </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col>
                                    <label class="cj-label">Profissional {{user && user.person.client.enable_multi_professional_telehealth_attendance && appointmentForm.appointmentFormat != null && appointmentForm.appointmentFormat.name == 'Online' && appointmentForm.send_telehealth_link ? 'Responsável' : ''}}</label>
                                    <validation-provider name="profissional" :rules="{ required: true }" v-slot="{ errors }">
                                        <multiselect v-model="appointmentForm.professional" :options="professionals" track-by="name" label="name" :preselectFirst="true" :allowEmpty="false" :showLabels="false" :searchable="true" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" placeholder="Selecione ou digite para buscar um profissional" @select="professionalSelected" :class="{ 'error': errors.length > 0 }"></multiselect>
                                        <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2" v-if="user && user.person.client.enable_multi_professional_telehealth_attendance && appointmentForm.appointmentFormat != null && appointmentForm.appointmentFormat.name == 'Online' && appointmentForm.send_telehealth_link">
                              <b-col>
                                <label class="cj-label">Profissionais participantes na teleconsulta</label>
                                <multiselect v-model="appointmentForm.telehealthAttendanceSpectators" :options="professionals" track-by="name" label="name" :preselectFirst="false" :showLabels="false" :allowEmpty="true" :searchable="true" :multiple="true" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" placeholder="Profissionais participantes na teleconsulta"></multiselect>
                              </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col v-show="appointmentForm.patient.id == null && !appointmentForm.patient.new">
                                    <label class="cj-label">Paciente</label>
                                    <validation-provider name="paciente" :rules="{ required: (appointmentForm.patient.id == null && !appointmentForm.patient.new) }" v-slot="{ errors }">
                                        <multiselect ref="multiselectPatient" :preserveSearch="true" v-model="appointmentForm.selectedPatient" :options="patients" :custom-label="nameWithInternalCode" track-by="name" label="name" :loading="isLoadingPatients" :internal-search="false" :options-limit="20" :limit="5" :limit-text="limitPatients" :max-height="200" @select="patientSelected" @search-change="findPatients" :showLabels="false" placeholder="Selecione um Paciente" :class="{ 'error': errors.length > 0 }">
                                            <template slot="noOptions">
                                                <div>
                                                    Digite para pesquisar seus pacientes...
                                                </div>
                                            </template>
                                            <template slot="noResult" v-if="!isLoadingPatients">
                                                <div>
                                                    Nenhum paciente encontrado...
                                                </div>
                                            </template>
                                            <template slot="afterList">
                                                <li @click="newPatient">
                                                    <div class="multiselect__option new-patient">
                                                        <i class="far fa-plus-circle mr-2"></i>
                                                        Adicionar novo paciente
                                                    </div>
                                                </li>
                                            </template>
                                        </multiselect>
                                        <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-col>
                                <b-col cols="9" v-show="appointmentForm.patient.id != null || appointmentForm.patient.new">
                                    <label class="cj-label">Nome</label>
                                    <validation-provider name="nome" :rules="{ required: (appointmentForm.patient.id != null || appointmentForm.patient.new) }" v-slot="{ errors }">
                                        <b-form-input type="text" v-model="appointmentForm.patient.name" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" :class="{ 'error': errors.length > 0 }" :readonly="appointmentForm.patient.id != null" autocomplete="off"></b-form-input>
                                        <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-col>
                                <b-col cols="3" v-show="appointmentForm.patient.id != null || appointmentForm.patient.new" class="align-self-end">
                                    <b-button block size="sm" variant="link" @click="changePatient" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))">Trocar</b-button>
                                </b-col>
                            </b-row>
                            <div v-show="appointmentForm.patient.id != null && ((appointmentForm.patient.responsible_name != null && appointmentForm.patient.responsible_name != '') || (appointmentForm.patient.responsible_document != null && appointmentForm.patient.responsible_document != '') || (appointmentForm.patient.responsible_kinship != null && appointmentForm.patient.responsible_kinship != '') || (appointmentForm.patient.responsible_email != null && appointmentForm.patient.responsible_email != '') || (appointmentForm.patient.responsible_phone != null && appointmentForm.patient.responsible_phone != '') || (appointmentForm.patient.responsible_notes != null && appointmentForm.patient.responsible_notes != ''))">
                                <b-col class="p-3 mb-2 background-color-whisper">
                                    <h6>Informações do(a) responsável</h6>
                                    <p class="small mb-0"><b>Nome:</b> {{ appointmentForm.patient.responsible_name }}</p>
                                    <p class="small mb-0"><b>CPF:</b> {{ appointmentForm.patient.responsible_document }}</p>
                                    <p class="small mb-0"><b>Parentesco:</b> {{ appointmentForm.patient.responsible_kinship }}</p>
                                    <p class="small mb-0"><b>E-mail:</b> {{ appointmentForm.patient.responsible_email }}</p>
                                    <p class="small mb-0"><b>Telefone:</b> {{ appointmentForm.patient.responsible_phone }}</p>
                                    <p class="small mb-0"><b>Notas:</b> {{ appointmentForm.patient.responsible_notes }}</p>
                                </b-col>
                            </div>
                            <div v-show="appointmentForm.patient.id != null && ((appointmentForm.patient.responsible2_name != null && appointmentForm.patient.responsible2_name != '') || (appointmentForm.patient.responsible2_document != null && appointmentForm.patient.responsible2_document != '') || (appointmentForm.patient.responsible2_kinship != null && appointmentForm.patient.responsible2_kinship != '') || (appointmentForm.patient.responsible2_email != null && appointmentForm.patient.responsible2_email != '') || (appointmentForm.patient.responsible2_phone != null && appointmentForm.patient.responsible2_phone != '') || (appointmentForm.patient.responsible2_notes != null && appointmentForm.patient.responsible2_notes != ''))">
                                <b-col class="p-3 mb-2 background-color-whisper">
                                    <h6>Informações do(a) responsável 2</h6>
                                    <p class="small mb-0"><b>Nome:</b> {{ appointmentForm.patient.responsible2_name }}</p>
                                    <p class="small mb-0"><b>CPF:</b> {{ appointmentForm.patient.responsible2_document }}</p>
                                    <p class="small mb-0"><b>Parentesco:</b> {{ appointmentForm.patient.responsible2_kinship }}</p>
                                    <p class="small mb-0"><b>E-mail:</b> {{ appointmentForm.patient.responsible2_email }}</p>
                                    <p class="small mb-0"><b>Telefone:</b> {{ appointmentForm.patient.responsible2_phone }}</p>
                                    <p class="small mb-0"><b>Notas:</b> {{ appointmentForm.patient.responsible2_notes }}</p>
                                </b-col>
                            </div>
                            <div v-show="appointmentForm.patient.id != null || appointmentForm.patient.new">
                                <b-row class="mb-2">
                                    <b-col cols="12" md="4">
                                        <label class="cj-label">Cód. Interno</label>
                                        <b-form-input type="text" v-model="appointmentForm.patient.internal_code" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" autocomplete="off"></b-form-input>
                                    </b-col>
                                    <b-col cols="12" md="8">
                                        <label class="cj-label">E-mail</label>
                                        <b-form-input type="email" v-model="appointmentForm.patient.email" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" autocomplete="off"></b-form-input>
                                    </b-col>
                                </b-row>
                                <b-row class="mb-2">
                                    <b-col>
                                        <label class="cj-label">Data de Nascimento</label>
                                        <date-picker name="date" v-model="appointmentForm.patient.birthday" v-mask="'##/##/####'" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" :config="datePickerOptions"></date-picker>
                                    </b-col>
                                    <b-col>
                                        <label class="cj-label">Celular ou Telefone Fixo</label>
                                        <b-form-input type="tel" v-model="appointmentForm.patient.telephone" v-mask="['(##) ####-####', '(##) #####-####']" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" autocomplete="off"></b-form-input>
                                    </b-col>
                                </b-row>
                            </div>
                            <b-row class="mb-2">
                                <b-col>
                                    <label class="cj-label">Convênio</label>
                                    <validation-provider name="convênio" :rules="{ required: true }" v-slot="{ errors }">
                                        <multiselect v-model="appointmentForm.healthPlan" :options="getProfessionalHealthPlans()" track-by="name" label="name" :allowEmpty="false" :showLabels="false" :searchable="true" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" placeholder="Selecione ou digite para buscar um convênio" :class="{ 'error': errors.length > 0 }"></multiselect>
                                        <span class="cj-error">{{ errors[0] }}</span>
                                    </validation-provider>
                                </b-col>
                                <b-col>
                                  <label class="cj-label">Número da Carteira</label>
                                  <b-form-input type="tel" v-model="appointmentForm.patient.card_number" v-mask="'########################################'" :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))" autocomplete="off"></b-form-input>
                                </b-col>
                            </b-row>
                            <b-row v-if="appointmentForm.paid_invoice != null">
                              <b-col>
                                <div class="alert text-center alert-success" role="alert">
                                  <p class="mb-0">Pagamento online: R$ {{formatPrice(appointmentForm.paid_invoice.value_in_cents/100.0)}}{{(helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR') ? ' - ' : ''}}<router-link v-if="helpers.isOwner() || user.person.type == 'SECRETARY' || user.person.type == 'COORDINATOR'" target="_blank" tag="a" :to="'/financeiro/transacoes/'+appointmentForm.paid_invoice.id">ver detalhes</router-link></p>
                                </div>
                              </b-col>
                            </b-row>
                            <b-row class="mb-3">
                                <b-col>
                                    <label class="cj-label">Observações internas</label>
                                    <b-form-textarea v-model="appointmentForm.notes" rows="2" max-rows="5" no-resize :disabled="(agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))"></b-form-textarea>
                                </b-col>
                            </b-row>
                            <b-row>
                                <b-col cols="12" class="mb-1">
                                    <div class="pretty p-switch p-fill">
                                        <input type="checkbox" v-model="appointmentForm.send_whatsapp" :disabled="disableWhatsappAndSms || ((agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))) || (appointmentForm.patient.telephone != null && appointmentForm.patient.telephone.length < 15)" />
                                        <div class="state p-success">
                                            <label><span>Autoriza o envio de Whatsapp para confirmação</span></label>
                                        </div>
                                    </div>
                                    <router-link v-if="whatsapps.length === 0" tag="a" to="/configuracoes/contas-de-whatsapp/cadastrar-conta-de-whatsapp" style="font-size: 14px">Cadastrar Whatsapp da clínica</router-link>
                                </b-col>
<!--                                <b-col cols="12" class="mb-1" v-if="appointmentForm.send_whatsapp && appointmentForm.patient.id == '638B07D8-4EB8-427A-8036-7AE4ABCF6793'">-->
<!--                                  <b-row>-->
<!--                                    <b-col>-->
<!--                                      <label class="cj-label">WhatsApp conectado</label>-->
<!--                                      <b-form-input type="tel" value="+1 (555) 171-9820" :readonly="true"></b-form-input>-->
<!--                                    </b-col>-->
<!--                                    <b-col>-->
<!--                                      <label class="cj-label">Template</label>-->
<!--                                      <multiselect v-model="template" :options="[{ value: null, name: 'lembrete_agendamento' }]" track-by="name" label="name" :allowEmpty="false" :showLabels="false" :searchable="true" placeholder="Selecione ou digite para buscar um template"></multiselect>-->
<!--                                    </b-col>-->
<!--                                  </b-row>-->
<!--                                </b-col>-->
                                <b-col cols="12" class="mb-1">
                                    <div class="pretty p-switch p-fill">
                                        <input type="checkbox" v-model="appointmentForm.send_sms" :disabled="disableWhatsappAndSms || ((agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))) || (appointmentForm.patient.telephone != null && appointmentForm.patient.telephone.length < 15)" />
                                        <div class="state p-success">
                                            <label><span>Autoriza o envio de SMS para confirmação</span></label>
                                        </div>
                                    </div>
                                </b-col>
                                <b-col cols="12">
                                    <div class="pretty p-switch p-fill">
                                        <input type="checkbox" v-model="appointmentForm.to_anticipate" :disabled="((agenda != null && !agenda.can_manage) || appointmentForm.status == 'ATTENDED' || dateIsBefore(appointmentForm.dateTime.startDate, moment().startOf('day'))) || (appointmentForm.id == null && differenceToNow(appointmentForm.dateTime.startDate) <= 24)" />
                                        <div class="state p-success">
                                            <label><span>Autoriza a antecipar o horário</span></label>
                                        </div>
                                    </div>
                                </b-col>
                            </b-row>
                        </div>
                        <div v-else>
                            <b-row class="mb-2">
                                <b-col>
                                    <label class="cj-label">Selecione o período do bloqueio</label>
                                    <date-range-picker
                                      class="w-100"
                                      ref="picker"
                                      :localeData="dateRangePickerPtBrLocale"
                                      :timePicker="true"
                                      :timePicker24Hour="true"
                                      :showDropdowns="true"
                                      :ranges="false"
                                      :showWeekNumbers="true"
                                      v-model="appointmentForm.dateTime">
                                        <div slot="input" slot-scope="picker" class="">
                                            {{ moment(picker.startDate).format('DD/MM/YYYY HH:mm') }} - {{ moment(picker.endDate).format('DD/MM/YYYY HH:mm') }}
                                        </div>
                                    </date-range-picker>
                                </b-col>
                            </b-row>
                            <b-row class="mb-2">
                                <b-col>
                                    <label class="cj-label">Título</label>
                                    <b-form-input type="text" v-model="appointmentForm.name" :disabled="(agenda != null && !agenda.can_manage)" autocomplete="off"></b-form-input>
                                </b-col>
                            </b-row>
                        </div>
                    </b-container>
                </validation-observer>
            </template>
            <template slot="modal-footer">
                <b-button size="sm" @click="$bvModal.hide('appointment-modal')">Fechar</b-button>

                <div v-if="(agenda != null && agenda.can_manage) && (appointmentForm.id == null || (appointmentForm.id != null && appointmentForm.status != 'ATTENDED' && ((appointmentForm.type == 'Agendamento' && (appointmentForm.dateTime.startDate instanceof moment ? appointmentForm.dateTime.startDate : this.moment(appointmentForm.dateTime.startDate)).isSameOrAfter(moment().startOf('day'))) || appointmentForm.type == 'Bloqueio')))">
                    <b-button-group size="sm" v-if="appointmentForm.id != null && (appointmentForm.dateTime.startDate instanceof moment ? appointmentForm.dateTime.startDate : this.moment(appointmentForm.dateTime.startDate)).isSameOrAfter(moment().startOf('day'))" class="mr-1">
                        <b-button variant="success" v-if="appointmentForm.id != null && appointmentForm.type == 'Agendamento' && ['SCHEDULED', 'CONFIRMED'].indexOf(appointmentForm.status) >= 0 && appointmentForm.date.isSameOrBefore(moment())" @click="saveAppointment('show')">Compareceu</b-button>
                        <b-button variant="danger" v-if="appointmentForm.id != null && appointmentForm.type == 'Agendamento' && ['SCHEDULED', 'CONFIRMED'].indexOf(appointmentForm.status) >= 0 && appointmentForm.date.isSameOrBefore(moment())" @click="saveAppointment('miss')">Faltou</b-button>
                        <b-button variant="primary" v-if="appointmentForm.id != null && appointmentForm.type == 'Agendamento' && appointmentForm.status == 'SCHEDULED'" @click="saveAppointment('confirm')">Confirmar</b-button>
                    </b-button-group>
                    <b-button-group size="sm">
                        <b-button variant="danger" v-if="appointmentForm.id != null" @click="saveAppointment('cancel')">{{ appointmentForm.type == 'Agendamento'?'Cancelar':'Remover'}}</b-button>
                        <b-button variant="success" @click="saveAppointment(null)" :disabled="!canPerformAction">Salvar</b-button>
                    </b-button-group>
                </div>
            </template>
        </b-modal>

        <b-modal id="attendance-guide-modal" class="attendance-guide-modal" size="xl" ignore-enforce-focus-selector=".swal2-input" :modalClass="'attendance-guide-modal'" @hidden="resetAttendanceGuideModal">
          <template slot="modal-header">
            <div class="w-100 d-flex justify-content-between">
              <div>
                Guia de Atendimento para {{ attendanceGuideForm.name }}
              </div>
<!--              <div v-if="attendanceGuideForm.id != null">-->
<!--                <span class="print-ico" @click="print"><i class="far fa-print"></i></span>-->
<!--              </div>-->
            </div>
          </template>
          <template slot="default">
            <b-col>
              <validation-observer ref="attendanceGuideForm" v-slot="{ invalid }">
                <b-row class="mb-3">
                  <b-col>
                    <label class="cj-label">Convênio</label>
                    <validation-provider name="convênio" :rules="{ required: true }" v-slot="{ errors }">
                      <multiselect v-model="attendanceGuideForm.health_plan" :options="attendanceGuideHealthPlans" track-by="name" label="name" :preselectFirst="attendanceGuideHealthPlans.length === 1" :allowEmpty="false" :showLabels="false" :searchable="true" :disabled="(agenda != null && !agenda.can_manage)" placeholder="Selecione ou digite para buscar um convênio" :class="{ 'error': errors.length > 0 }"></multiselect>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Profissional</label>
                    <b-form-input type="text" v-model="attendanceGuideForm.professional" :disabled="true" autocomplete="off"></b-form-input>
                  </b-col>
                  <b-col>
                    <label class="cj-label">Forma de faturamento</label>
                    <validation-provider name="forma de faturamento" :rules="{ required: true }" v-slot="{ errors }">
                      <multiselect v-model="attendanceGuideForm.bill_type" :options="billTypeOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="false" :showLabels="false" :searchable="true" :disabled="(agenda != null && !agenda.can_manage)" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                      <span class="cj-error">{{ errors[0] }}</span>
                    </validation-provider>
                  </b-col>
                </b-row>
              </validation-observer>
              <hr>
              <validation-observer ref="attendanceGuideItemForm" v-slot="{ invalid }">
                <b-col class="p-3 mb-3 background-color-whisper">
                  <b-row v-if="attendanceGuideForm.is_dentist" class="mb-2">
                    <b-col>
                      <label class="cj-label">Dente/Área</label>
                      <validation-provider name="dente/área" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect v-model="attendanceGuideForm.item.tooth" :options="teeth" :showLabels="false" :searchable="true" placeholder="Dente/Área" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Face(s)</label>
<!--                      <validation-provider name="face" :rules="{ required: (typeof attendanceGuideForm.item.tooth === 'number') || (attendanceGuideForm.item.tooth != null && !isNaN(attendanceGuideForm.item.tooth)) }" v-slot="{ errors }">-->
                      <validation-provider name="face(s)" :rules="{ required: false }" v-slot="{ errors }">
                        <multiselect v-model="attendanceGuideForm.item.faces" :options="faces" :showLabels="false" :searchable="true" :multiple="true" placeholder="Face(s)" :class="{ 'error': errors.length > 0 }"></multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-3">
                    <b-col cols="12" md="6">
                      <label class="cj-label">Procedimento</label>
                      <validation-provider name="procedimento" :rules="{ required: true }" v-slot="{ errors }">
                        <multiselect ref="multiselectProcedure" :preserveSearch="true" v-model="attendanceGuideForm.item.procedure" :options="attendanceGuideProcedures" track-by="name" label="name" :loading="isLoadingAttendanceGuideProcedures" :internal-search="false" :options-limit="20" :limit="5" :max-height="200" @search-change="findAttendanceGuideProcedures" :showLabels="false" placeholder="Selecione um procedimento" :class="{ 'error': errors.length > 0 }">
                          <template slot="noOptions">
                            <div>
                              Digite para pesquisar procedimentos...
                            </div>
                          </template>
                          <template slot="noResult" v-if="!isLoadingAttendanceGuideProcedures">
                            <div>
                              Nenhum procedimento encontrado...
                            </div>
                          </template>
                        </multiselect>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Quantidade</label>
                      <validation-provider name="quantidade" :rules="{ required: true }" v-slot="{ errors }">
                        <b-form-input v-model="attendanceGuideForm.item.amount" type="number" min="1" step="1" :class="{ 'error': errors.length > 0 }" autocomplete="off"></b-form-input>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                    <b-col>
                      <label class="cj-label">Valor</label>
                      <validation-provider name="valor" :rules="{ required: true }" v-slot="{ errors }">
                        <money v-model="attendanceGuideForm.item.value" class="form-control" :class="{ 'error': errors.length > 0 }"></money>
                        <span class="cj-error">{{ errors[0] }}</span>
                      </validation-provider>
                    </b-col>
                  </b-row>
                  <b-row class="mb-2 justify-content-end">
                    <b-col cols="auto">
                      <b-button variant="success" @click="addItemToAttendanceGuide">Adicionar</b-button>
                    </b-col>
                  </b-row>
                </b-col>
              </validation-observer>

              <table class="table table-responsive w-100 d-block d-md-table table-centered table-cj">
                <thead>
                <tr>
                  <th v-if="attendanceGuideForm.is_dentist">Dente/Área</th>
                  <th v-if="attendanceGuideForm.is_dentist">Face(s)</th>
                  <th>Procedimento</th>
                  <th>Quantidade</th>
                  <th>Valor</th>
                  <th class="text-center">Realizado?</th>
                  <th class="text-center"></th>
                </tr>
                </thead>
                <tbody>
                <tr v-for="(item, index) of attendanceGuideForm.items" :key="index">
                  <td v-if="attendanceGuideForm.is_dentist">{{ item.tooth != null ? item.tooth : '-' }}</td>
                  <td v-if="attendanceGuideForm.is_dentist">{{ item.faces != null ? item.faces : '-' }}</td>
                  <td>{{ item.procedure.name }}</td>
                  <td>{{ item.amount }}</td>
                  <td>R$ {{ formatPrice(item.value) }}</td>
                  <td class="text-center">
                    <div class="pretty p-switch p-fill">
                      <input type="checkbox" v-model="item.accomplished" />
                      <div class="state p-success">
                        <label></label>
                      </div>
                    </div>
                  </td>
                  <td class="text-center">
                    <b-button size="sm" variant="danger" @click="removeItemFromAttendanceGuide(index)"><i class="far fa-trash-alt"></i></b-button>
                  </td>
                </tr>
                <tr v-if="attendanceGuideForm.items.length == 0">
                  <td :colspan="(attendanceGuideForm.is_dentist ? 7 : 5)" class="text-center">
                    Nenhum item adicionado à guia.
                  </td>
                </tr>
                </tbody>
                <tfoot v-if="attendanceGuideForm.items.length > 0">
                <tr>
                  <td v-if="attendanceGuideForm.is_dentist"></td>
                  <td v-if="attendanceGuideForm.is_dentist"></td>
                  <td></td>
                  <td class="text-right">Total:</td>
                  <td>R$ {{ formatPrice(attendanceGuideForm.items.reduce((total, item) => total + item.value, 0)) }}</td>
                  <td></td>
                  <td></td>
                </tr>
                </tfoot>
              </table>
            </b-col>
          </template>
          <template slot="modal-footer">
            <b-button size="sm" @click="$bvModal.hide('attendance-guide-modal')">Fechar</b-button>
            <b-button size="sm" variant="success" @click="saveAttendanceGuide(false)">Salvar</b-button>
            <b-button v-if="helpers.planHasPermission('financial') && attendanceGuideForm.bill_type != null" size="sm" variant="primary" @click="billAttendanceGuide()">Faturar</b-button>
          </template>
        </b-modal>
        <b-modal id="directing-modal" class="directing-modal" :modalClass="'directing-modal'" @hidden="resetDirectingModal">
          <template slot="modal-header">
            Encaminhar paciente
          </template>
          <template slot="default">
            <validation-observer ref="directingForm" v-slot="{ invalid }">
              <b-row class="mb-2">
                <b-col>
                  <label class="cj-label">Setor</label>
                  <validation-provider name="setor" :rules="{ required: true }" v-slot="{ errors }">
                    <multiselect v-model="directingForm.directing_sector" :options="directingSectorOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="false" :showLabels="false" :searchable="true" @select="sectorSelected" placeholder="Selecione" :class="{ 'error': errors.length > 0 }"></multiselect>
                    <span class="cj-error">{{ errors[0] }}</span>
                  </validation-provider>
                </b-col>
              </b-row>
              <b-row v-if="directingForm.directing_sector != null && directingSectorProfessionalOptions.length > 0">
                <b-col>
                  <label class="cj-label">Profissional (opcional)</label>
                  <validation-provider name="profissional" :rules="{ required: false }" v-slot="{ errors }">
                    <multiselect v-model="directingForm.professional" :options="directingSectorProfessionalOptions" track-by="name" label="name" :preselectFirst="false" :allowEmpty="true" :showLabels="false" :searchable="true" placeholder="Selecione" :class="{ 'error': errors.length > 0 }">
                      <template slot="clear">
                        <div class="multiselect__clear" v-if="directingForm.professional != null" @mousedown.prevent.stop="directingForm.professional = null"></div>
                      </template>
                    </multiselect>
                    <span class="cj-error">{{ errors[0] }}</span>
                  </validation-provider>
                </b-col>
              </b-row>
            </validation-observer>
          </template>
          <template slot="modal-footer">
            <b-button size="sm" @click="$bvModal.hide('directing-modal')">Fechar</b-button>
            <b-button size="sm" variant="success" @click="saveDirecting">Encaminhar</b-button>
          </template>
        </b-modal>

        <div class="backdrop" v-if="eventSelected != null" @click="removeEventSelection"></div>
    </div>
</template>

<script>
    import FullCalendar from '@fullcalendar/vue'
    import dayGridPlugin from '@fullcalendar/daygrid'
    import timeGridPlugin from '@fullcalendar/timegrid'
    import interactionPlugin from '@fullcalendar/interaction'

    export default {
        name: 'agenda',
        components: {
            FullCalendar
        },
        data() {
            return {
                leavingPage: false,
                user: null,

                aolUrl: process.env.VUE_APP_AOL_URL,

                disableWhatsappAndSms: false,

                telehealthAvailableMinutes: null,

                firstDay: parseInt(this.moment().format('d')),

                currentView: (this.$attrs['isMobile'])?'day':'week',
                currentLabel: '',
                currentDate: '',
                currentRange: { startDate: this.moment(), endDate: this.moment().add(6, 'days') },

                eventSelected: null,

                calendarPlugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
                calendarEvents: [],

                agenda: null,
                agendas: [],
                agendaConfig: {
                  slotDuration: '00:30:00',
                  minDate: this.moment().subtract(1, 'years').format('YYYY-MM-DD'),
                  minTime: '08:00:00',
                  maxDate: this.moment().add(1, 'years').format('YYYY-MM-DD'),
                  maxTime: '18:00:00'
                },

                professionals: [],
                patients: [],
                isLoadingPatients: false,
                findPatientsTimer: null,

                whatsapps: [],
                directingSectorOptions: [],
                directingSectorProfessionals: {},
                directingSectorProfessionalOptions: [],

                selectedPatient: null,
                appointmentForm: {
                  id: null,
                  type: 'Agendamento',
                  date: this.moment(),
                  dateTime: { startDate: this.moment().set({ hour: 8, minute: 0 }), endDate: this.moment().set({ hour: 8, minute: 30 }) },
                  startTime: this.moment('08:00', 'HH:mm'),
                  endTime: this.moment('08:30', 'HH:mm'),
                  professional: null,
                  telehealthAttendanceSpectators: [],
                  appointmentType: null,
                  appointmentFormat: null,
                  name: '',
                  patient: {
                    id: null,
                    value: null,
                    new: false,
                    name: '',
                    internal_code: '',
                    email: '',
                    birthday: '',
                    telephone: '',
                    card_number: '',
                  },
                  healthPlan: null,
                  notes: '',
                  send_telehealth_link: true,
                  send_sms: false,
                  send_whatsapp: false,
                  to_anticipate: false,
                  notificationBy: [],
                  repeat_id: null
                },

                canPerformAction: true,

                appointmentTypes: [],
                appointmentFormats: [],

                typeOptions: ['Agendamento', 'Bloqueio'],
                notificationTypes: [
                    { text: 'Enviar Whatsapp?', value: 'whatsapp' },
                    { text: 'Enviar Sms?', value: 'sms' }
                ],

                dateRangePickerPtBrLocale : {
                    locale: 'pt-BR',
                    direction: 'ltr',
                    format: this.moment().localeData().longDateFormat('L'),
                    separator: ' até ',
                    applyLabel: 'Aplicar',
                    cancelLabel: 'Cancelar',
                    weekLabel: 'W',
                    daysOfWeek: this.moment().localeData().weekdaysMin(),
                    monthNames: this.moment().localeData().monthsShort()
                },

                dateRangePickerDatesClasses: {},
                lastDateRangePickerAgendaMonth: null,

                datePickerOptions: {
                    format: 'DD/MM/YYYY',
                    useCurrent: false,
                    locale: 'pt-br'
                },

                repeatTypes: [
                    { value: false, name: 'Não se repete' },
                    { value: true, name: 'Repete-se' }
                ],

                repeatOptions: [
                    { value: 'day', name: 'Dia(s)' },
                    { value: 'week', name: 'Semana(s)' },
                    { value: 'month', name: 'Mês(es)' },
                    { value: 'year', name: 'Ano(s)' }
                ],

                repeatMonthOptions: [],

                endedOptions: [
                    { value: 'repeats', name: 'Após n ocorrências' },
                    { value: 'never', name: 'Nunca' },
                    { value: 'specific-date', name: 'Em uma data' }
                ],

                repeatForm: {
                    enabled: { value: false, name: 'Não se repete' },
                    option: { value: 'day', name: 'Dia(s)' },
                    month: null,
                    interval: null,
                    daysOfWeek: [],
                    end: { value: 'never', name: 'Nunca' },
                    endValue: null
                },


                teeth: ['Boca toda', 'Arcada Superior', 'Arcada Inferior', 11, 12, 13, 14, 15, 16, 17, 18, 21, 22, 23, 24, 25, 26, 27, 28, 31, 32, 33, 34, 35, 36, 37, 38, 41, 42, 43, 44, 45, 46, 47, 48, 51, 52, 53, 54, 55, 61, 62, 63, 64, 65, 71, 72, 73, 74, 75, 81, 82, 83, 84, 85],
                faces: ['Vestibular', 'Palatina', 'Lingual', 'Mesial', 'Distal', 'Oclusal', 'Incisal'],

                billTypeOptions: [
                  { value: 'accomplished_procedures', name: 'Por procedimento realizado' },
                  { value: 'full_guide', name: 'Guia completa' }
                ],

                attendanceGuideForm: {
                  appointment_id: null,
                  patient_id: null,
                  name: '',
                  professional: '',
                  bill_type: null,
                  is_dentist: false,
                  health_plan: null,
                  authorization_code: '',
                  // title: '',
                  // professional: null,
                  // status: '',
                  items: [],
                  item: {
                    tooth: null,
                    faces: null,
                    procedure: null,
                    amount: 1,
                    value: 0,
                    accomplished: false
                  }
                },

                attendanceGuideHealthPlans: [],
                attendanceGuideProcedures: [],
                isLoadingAttendanceGuideProcedures: false,
                findAttendanceGuideProceduresTimer: null,

                directingForm: {
                  appointment_id: null,
                  directing_sector: null,
                  professional: null,
                }
            }
        },
        mounted () {
          this.user = JSON.parse(localStorage.getItem('user'));

          if(this.user.person.client.mandic_campaign && this.user.person.client.mandic_campaign.trial_active === 0 && this.user.person.client.mandic_campaign.subscription_active === 0) {
            this.disableWhatsappAndSms = true;
          }

          document.addEventListener('focusin', function (e) {
            let closest = e.target.closest('.swal2-input');
            if (closest !== null && closest !== undefined) {
              e.stopImmediatePropagation();
            }
          });

          if(this.user != null) {
              this.$nextTick(() => {
                  this.getCurrentLabel();
              });

              this.api.getAgendasData().then(res => {
                  if(this.leavingPage) {
                      return;
                  }
                  this.agendas = [];
                  res.data.agendas.forEach(agenda => {
                      let permission = agenda.permissions.find(permission => {
                          return permission.person_id == this.user.person.id
                      });
                      let can_manage = (permission != null) ? permission.can_manage : false;
                      this.agendas.push({
                          value: agenda.id,
                          name: agenda.name,
                          duration: agenda.duration,
                          schedules: agenda.schedules,
                          start_date: agenda.start_date,
                          end_date: agenda.end_date,
                          appointment_types: agenda.appointment_types,
                          appointment_formats: agenda.appointment_formats,
                          professionals: agenda.professionals,
                          calendar_preferences: agenda.calendar_preferences,
                          online_charging: agenda.online_charging,
                          charge_to_schedule_presential: agenda.charge_to_schedule_presential,
                          charge_to_schedule_online: agenda.charge_to_schedule_online,
                          can_manage: (this.helpers.isOwner()) ? true : can_manage
                      });
                  });

                  if (this.agendas.length > 0) {
                      if(JSON.parse(localStorage.getItem('appointmentsData')) != null) {
                          let appointmentsData = JSON.parse(localStorage.getItem('appointmentsData'));

                          let agendaSelected = this.agendas.find(agenda => agenda.value == appointmentsData.agenda_id);
                          if(agendaSelected) {
                              this.agenda = agendaSelected;

                              let agendaApi = this.$refs.agenda.getApi();
                              agendaApi.gotoDate(appointmentsData.start_date);

                              this.firstDay = parseInt(this.moment(appointmentsData.start_date).format('d'));
                              this.currentRange = { startDate: this.moment(appointmentsData.start_date), endDate: this.moment(appointmentsData.start_date).add(6, 'days') };

                              this.changeView(appointmentsData.view);
                          }
                      } else {
                          this.agenda = this.agendas[0];
                          this.getAgenda();
                      }
                  }

                  this.whatsapps = [];
                  res.data.whatsapps.forEach(whatsapp => {
                    this.whatsapps.push({value: whatsapp.id, name: whatsapp.name + ' - ' + whatsapp.number + (whatsapp.enabled ? '' : ' (desconectada)')});
                  });

                  this.telehealthAvailableMinutes = res.data.telehealth_available_minutes;

                  this.directingSectorOptions = [];
                  this.directingSectorProfessionals = {};
                  res.data.directing_sectors.forEach(directingSector => {
                    this.directingSectorOptions.push({value: directingSector.id, name: directingSector.name});
                    this.directingSectorProfessionals[directingSector.id] = [];
                    directingSector.professionals.forEach(professional => {
                      this.directingSectorProfessionals[directingSector.id].push({value: professional.id, name: professional.name});
                    });
                  });

                  if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                      console.log('Response Agendas Data', res);
              }).catch(err => {
                  if(this.leavingPage) {
                      return;
                  }
                  this.$swal('Ops...', 'Não conseguimos carregar as suas agendas! Por favor, entre em contato com o suporte!', 'error');
                  if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                      console.log('Error Agendas Data', err.response);
              });

              this.currentRange = {startDate: this.moment(), endDate: this.moment().add(6, 'days')};
          }
        },
        watch: {
            '$attrs': function(val) {
                if(val.isMobile)
                    this.changeView('day');
            },
            'appointmentForm.send_whatsapp': {
              handler(newValue) {
                if(newValue) {
                  this.appointmentForm.send_sms = false;
                }
              }
            },
            'appointmentForm.send_sms': {
              handler(newValue) {
                if(newValue) {
                  this.appointmentForm.send_whatsapp = false;
                }
              }
            },
            'attendanceGuideForm.item.procedure': {
              handler(newValue) {
                if(newValue != null) {
                  this.attendanceGuideForm.item.value = newValue.procedure_value * this.attendanceGuideForm.item.amount;
                }
              }
            },
            'attendanceGuideForm.item.amount': {
              handler(newValue) {
                if(this.attendanceGuideForm.item.procedure != null) {
                  this.attendanceGuideForm.item.value = this.attendanceGuideForm.item.procedure.procedure_value * newValue;
                }
              }
            }
        },
        methods: {
            async getAgenda() {
                let workingDays = [];
                let minTime = null;
                let maxTime = null;

                if(this.agenda != null) {
                    this.agenda.schedules.forEach(schedule => {
                        let sT = this.moment(schedule.start_time, 'HH:mm:ss');
                        let eT = this.moment(schedule.end_time, 'HH:mm:ss');

                        if (schedule.type == 'AVAILABLE') {
                            if (minTime == null || sT < minTime)
                                minTime = sT;

                            if (maxTime == null || eT > maxTime)
                                maxTime = eT;

                            workingDays.push({
                                dayOfWeek: schedule.day_of_week,
                                startTime: sT,
                                endTime: eT
                            });
                        }
                    });

                    this.agendaConfig.slotDuration = this.agenda.duration;
                    this.agendaConfig.minDate = this.agenda.start_date;
                    this.agendaConfig.minTime = minTime.format('HH:mm:ss');
                    this.agendaConfig.maxDate = this.agenda.end_date;
                    this.agendaConfig.maxTime = maxTime.format('HH:mm:ss');

                    this.appointmentTypes = [];
                    this.agenda.appointment_types.forEach(appointmentType => {
                      this.appointmentTypes.push({value: appointmentType.id, name: appointmentType.type});
                    });

                    this.appointmentFormats = [];
                    this.agenda.appointment_formats.forEach(appointmentFormat => {
                      this.appointmentFormats.push({value: appointmentFormat.id, name: appointmentFormat.format});
                    });

                    this.professionals = this.agenda.professionals.map(professional => {
                        let dentistSpecialty = professional.specialities.find(specialty => {
                          return specialty.group === 'Odontologia';
                        });
                        return {
                            value: professional.id,
                            name: professional.name,
                            health_plans: professional.health_plans.map(healthPlan => { return { 'value': healthPlan.id, 'name': healthPlan.name } }),
                            is_dentist: dentistSpecialty !== undefined
                        };
                    }).sort((a, b) => a.name.localeCompare(b.name));

                    await this.getAppointments();
                }
            },

            getAppointments() {
                try {
                    let nonWorkingDays = [];
                    let workingDays = [];
                    let breaks = [];
                    let events = [];
                    let minTime = null;
                    let maxTime = null;

                    this.calendarEvents = [];

                    this.agenda.schedules.forEach(schedule => {
                        let sT = this.moment(schedule.start_time, 'HH:mm:ss');
                        let eT = this.moment(schedule.end_time, 'HH:mm:ss');

                        if (schedule.type == 'AVAILABLE') {
                            if (minTime == null || sT < minTime)
                                minTime = sT;

                            if (maxTime == null || eT > maxTime)
                                maxTime = eT;

                            workingDays.push({
                                dayOfWeek: schedule.day_of_week,
                                startTime: sT,
                                endTime: eT
                            });
                        } else if (schedule.type == 'BREAK') {
                            breaks.push({
                                daysOfWeek: [schedule.day_of_week],
                                startTime: sT.format('HH:mm:ss'),
                                endTime: eT.format('HH:mm:ss'),
                                rendering: 'background'
                            });
                        }
                    });

                    this.agenda.schedules.forEach(schedule => {
                        let sT = this.moment(schedule.start_time, 'HH:mm:ss');
                        let eT = this.moment(schedule.end_time, 'HH:mm:ss');

                        if (schedule.type == 'AVAILABLE') {
                            if (sT > minTime) {
                                nonWorkingDays.push({
                                    className: 'non-working-days',
                                    daysOfWeek: [schedule.day_of_week],
                                    startTime: minTime.format('HH:mm:ss'),
                                    endTime: sT.format('HH:mm:ss'),
                                    rendering: 'background'
                                });
                            }

                            if (maxTime > eT) {
                                nonWorkingDays.push({
                                    className: 'non-working-days',
                                    daysOfWeek: [schedule.day_of_week],
                                    startTime: eT.format('HH:mm:ss'),
                                    endTime: maxTime.format('HH:mm:ss'),
                                    rendering: 'background'
                                });
                            }
                        }
                    });

                    for (let dow = 0; dow <= 6; dow++) {
                        let wD = workingDays.find(wD => wD.dayOfWeek == dow);
                        if (typeof wD == 'undefined') {
                            nonWorkingDays.push({
                                className: 'non-working-days',
                                daysOfWeek: [dow],
                                startTime: '00:00:00',
                                endTime: '24:00:00',
                                rendering: 'background'
                            });
                        }
                    }

                    let agendaApi = this.$refs.agenda.getApi();

                    if (agendaApi.view.type != 'timeGridDay' && this.$attrs['isMobile']) {
                        agendaApi.changeView('timeGridDay');
                    }

                    let view = agendaApi.view;
                    let startDate = this.moment(view.currentStart);
                    let endDate = this.moment(view.currentEnd).subtract(1, 'days');

                    let appointmentsData = {agenda_id: this.agenda.value};
                    if (this.currentView == 'month') {
                        appointmentsData.start_date = startDate.format('YYYY-MM-DD');
                        appointmentsData.end_date = endDate.format('YYYY-MM-DD');
                    } else if (this.currentView == 'week') {
                        appointmentsData.start_date = startDate.format('YYYY-MM-DD');
                        appointmentsData.end_date = endDate.format('YYYY-MM-DD');
                    } else {
                        appointmentsData.start_date = this.currentDate.format('YYYY-MM-DD');
                        appointmentsData.end_date = this.currentDate.format('YYYY-MM-DD');
                    }

                    events = [];
                    events = events.concat(nonWorkingDays, breaks);

                    appointmentsData.view = this.currentView;
                    localStorage.setItem('appointmentsData', JSON.stringify(appointmentsData));
                    delete appointmentsData.view;

                    this.api.getAppointments(appointmentsData).then(res => {
                        if(this.leavingPage) {
                            return;
                        }
                        let currentAgenda = this.agenda;
                        res.data.forEach(appointment => {
                            // Montar a grade de acordo com os agendamentos
                            // let sT = this.moment(appointment.start_datetime.substr(-8), 'HH:mm:ss');
                            // let eT = this.moment(appointment.end_datetime.substr(-8), 'HH:mm:ss');
                            //
                            // minAppointmentTime = (minAppointmentTime == null || sT < minAppointmentTime)?sT:minAppointmentTime;
                            // maxAppointmentTime = (maxAppointmentTime == null || eT > maxAppointmentTime)?eT:maxAppointmentTime;

                            if (!appointment.hide) {
                              let canceledForLackOfPayment = appointment.type == 'APPOINTMENT' && appointment.channel == 'online' && currentAgenda.online_charging && appointment.status == 'CANCELED' &&
                                  !appointment.paid_invoice && appointment.health_plan.name == 'Particular' &&
                                  ((appointment.appointment_format.format == 'Online' && currentAgenda.charge_to_schedule_online) || (appointment.appointment_format.format != 'Online' && currentAgenda.charge_to_schedule_presential));
                              events.push({
                                id: appointment.id,
                                classNames: [appointment.type.toLowerCase(), appointment.channel, appointment.status.toLowerCase(), appointment.changed_status_after_date ? 'changed_status_after_date' : '', canceledForLackOfPayment ? 'online-canceled-not-paid' : '', appointment.directings_count > 0 ? 'has_directing' : ''],
                                title: (appointment.type == 'APPOINTMENT') ? appointment.patient.name : (appointment.type == 'BLOCK') ? appointment.name : 'Fila em andamento',
                                start: appointment.start_datetime,
                                end: appointment.end_datetime,
                                appointment: appointment
                              });
                            }
                        });
                        this.calendarEvents = events;

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Response Appointments', res);
                    }).catch(err => {
                        if(this.leavingPage) {
                            return;
                        }
                        this.$swal('Ops...', 'Não conseguimos carregar os agendamentos desta agenda! Por favor, entre em contato com o suporte!', 'error');
                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Error Appointments', err.response);
                    });
                } catch(err) {
                  this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: getAppointments\nError:'+err.toString(), 'warning');
                  this.sentry.captureException(err);
                }
            },

            getDatesClasses(startDate = this.moment().startOf('month'), endDate = this.moment().endOf('month')) {
                if(this.agenda == null) {
                  return;
                }
                let appointmentsData = { agenda_id: this.agenda.value };
                appointmentsData.start_date = startDate.format('YYYY-MM-DD');
                appointmentsData.end_date = endDate.format('YYYY-MM-DD');

                this.api.getAppointments(appointmentsData).then(res => {
                    if(this.leavingPage) {
                        return;
                    }
                    this.dateRangePickerDatesClasses = {};
                    Object.entries(res.data).forEach(array => {
                        this.dateRangePickerDatesClasses[array[0]] = (array[1])?'vacancies':'no-vacancies';
                    });

                    if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                        console.log('Response Appointments', res);
                }).catch(err => {
                    if(this.leavingPage) {
                        return;
                    }
                    this.$swal('Ops...', 'Não conseguimos carregar os dias disponíveis desta agenda! Por favor, entre em contato com o suporte!', 'error');
                    if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                        console.log('Error Appointments', err.response);
                });
            },

            limitPatients(qty) {
                return 'e '+qty+' outros pacientes';
            },

            findPatients(query) {
                this.patients = [];
                if(query.length >= 3 && !this.isLoadingPatients) {
                  if(this.findPatientsTimer !== null) {
                    clearTimeout(this.findPatientsTimer);
                  }
                  this.findPatientsTimer = setTimeout(() => {
                    this.isLoadingPatients = true;
                    this.api.getPeople({type: 'PATIENT', name: query}).then(res => {
                      if(this.leavingPage) {
                        return;
                      }
                      this.isLoadingPatients = false;

                      res.data.data.forEach(patient => {
                        this.patients.push({
                          value: patient.id,
                          name: patient.name,
                          id: patient.id,
                          internal_code: patient.internal_code,
                          email: patient.email,
                          birthday: (this.moment(patient.birthday).isValid())?this.moment(patient.birthday).format('DD/MM/YYYY'):'',
                          telephone: patient.telephone !== null && patient.telephone !== '' ? patient.telephone : null,
                          cellphone: patient.cellphone !== null && patient.cellphone !== '' ? patient.cellphone : null,
                          card_number: patient.card_number,
                          responsible_name: patient.responsible_name,
                          responsible_document: patient.responsible_document,
                          responsible_kinship: patient.responsible_kinship,
                          responsible_email: patient.responsible_email,
                          responsible_phone: patient.responsible_phone,
                          responsible_notes: patient.responsible_notes,
                          responsible2_name: patient.responsible2_name,
                          responsible2_document: patient.responsible2_document,
                          responsible2_kinship: patient.responsible2_kinship,
                          responsible2_email: patient.responsible2_email,
                          responsible2_phone: patient.responsible2_phone,
                          responsible2_notes: patient.responsible2_notes
                        });
                      });
                    }).catch(err => {
                      if(this.leavingPage) {
                        return;
                      }
                      if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                        console.log('Error Patients', err.response);
                    });
                  }, 300);
                }
            },

            agendaSelected(selectedOption) {
                this.agenda = selectedOption;
                this.getAgenda();
            },

            patientSelected(selectedOption) {
                this.appointmentForm.patient = {
                    id: selectedOption.id,
                    value: selectedOption.value,
                    name: selectedOption.name,
                    internal_code: selectedOption.internal_code,
                    email: selectedOption.email,
                    birthday: selectedOption.birthday,
                    telephone: (selectedOption.cellphone != null)?selectedOption.cellphone:selectedOption.telephone,
                    card_number: (selectedOption.card_number != null)?selectedOption.card_number:selectedOption.card_number,
                    responsible_name: selectedOption.responsible_name,
                    responsible_document: selectedOption.responsible_document,
                    responsible_kinship: selectedOption.responsible_kinship,
                    responsible_email: selectedOption.responsible_email,
                    responsible_phone: selectedOption.responsible_phone,
                    responsible_notes: selectedOption.responsible_notes,
                    responsible2_name: selectedOption.responsible2_name,
                    responsible2_document: selectedOption.responsible2_document,
                    responsible2_kinship: selectedOption.responsible2_kinship,
                    responsible2_email: selectedOption.responsible2_email,
                    responsible2_phone: selectedOption.responsible2_phone,
                    responsible2_notes: selectedOption.responsible2_notes
                }
            },

            changePatient() {
                this.appointmentForm.selectedPatient = null;
                this.appointmentForm.patient = {
                    id: null,
                    value: null,
                    new: false,
                    name: '',
                    internal_code: '',
                    email: '',
                    birthday: '',
                    telephone: '',
                    card_number: ''
                };
                this.$forceUpdate();
            },

            professionalSelected(selectedOption) {
                this.appointmentForm.healthPlan = (selectedOption['health_plans'].length > 0)?selectedOption['health_plans'][0]:null;
            },

            resetAppointmentModal() {
                try {
                    this.appointmentForm = {
                        id: null,
                        type: 'Agendamento',
                        date: this.moment(),
                        dateTime: { startDate: this.moment().set({ hour: 8, minute: 0 }), endDate: this.moment().set({ hour: 8, minute: 30 }) },
                        startTime: this.moment('08:00', 'HH:mm'),
                        endTime: this.moment('08:30', 'HH:mm'),
                        professional: null,
                        telehealthAttendanceSpectators: [],
                        appointmentType: null,
                        appointmentFormat: null,
                        name: '',
                        patient: {
                            id: null,
                            new: false,
                            name: '',
                            internal_code: '',
                            email: '',
                            birthday: '',
                            telephone: '',
                            card_number: ''
                        },
                        healthPlan: null,
                        notes: '',
                        send_telehealth_link: true,
                        send_sms: false,
                        send_whatsapp: false,
                        to_anticipate: false,
                        notificationBy: [],
                        telehealth_attendance: null,
                        paid_invoice: null
                    };

                    this.repeatForm = {
                        enabled: { value: false, name: 'Não se repete' },
                        option: { value: 'day', name: 'Dia(s)' },
                        month: null,
                        interval: null,
                        daysOfWeek: [],
                        end: { value: 'never', name: 'Nunca' },
                        endValue: null
                    };

                    this.removeEventSelection();
                    this.$forceUpdate();
                } catch(err) {
                    this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: storeAppointment\nError:'+err.toString(), 'warning');
                    this.sentry.captureException(err);
                }
            },

            async saveAppointment(type) {
                if(!this.canPerformAction)
                    return false;

                if(this.appointmentForm.id != null && this.appointmentForm.repeat_id != null && type == 'cancel') {
                  let doCancel = false;
                  let cancelType = 'this';

                  await this.$swal({
                    title: 'Excluir agendamento recorrente',
                    input: 'select',
                    inputOptions: {
                      this: 'Este agendamento',
                      future: 'Este e os agendamentos futuros',
                      all: 'Todos os agendamentos'
                    },
                    showCancelButton: true,
                    cancelButtonText: 'Cancelar',
                    inputValidator: (value) => {
                      cancelType = value;
                    }
                  }).then((res) => {
                    if(res.value) {
                      doCancel = true;
                    }
                  });

                  if(doCancel) {
                    await this.api.cancelAppointment(this.appointmentForm.id, cancelType).then(res => {
                      if(this.leavingPage) {
                         return;
                      }
                      this.$swal('Parabéns...', (this.appointmentForm.type == ('Agendamento'))?'Agendamento cancelado com sucesso!':'Bloqueio removido com sucesso!', 'success');

                      this.getAgenda();
                      this.$bvModal.hide('appointment-modal');

                      if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                        console.log('Response Cancel Appointment', res);
                    }).catch(err => {
                      if(this.leavingPage) {
                          return;
                      }
                      try {
                        this.removeEventSelection();

                        let response = err.response;
                        let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cancelar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                        this.$swal('Ops...', message, 'error');
                      } catch(err2) {
                        this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchCancelAppointment\nError:'+err.toString(), 'warning');
                        this.sentry.captureException(err);
                      }
                      if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                        console.log('Error Cancel  Appointment', err);
                    });
                  }
                  return;
                }

                this.canPerformAction = false;

                const isValid = await this.$refs.appointmentForm.validate();
                if(!isValid) {
                    this.canPerformAction = true;
                    return false;
                }
                let sentTelehealthLink = this.appointmentForm.type == 'Agendamento' && this.appointmentForm.appointmentFormat.name == 'Online' && this.appointmentForm.send_telehealth_link;
                if(sentTelehealthLink && !this.helpers.planHasPermission('telehealth')) {

                  let canManageSubscription = (this.helpers.isOwner())?true:this.helpers.checkPermission('subscription', 'can_manage'),
                    warningMessage = 'Para utilizar a funcionalidade de enviar lembrete e link da teleconsulta, é necessário ativar o plano de TELECONSULTA!';
                  if(canManageSubscription) {
                    await this.$swal({
                      title: 'Atenção',
                      text: warningMessage,
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'Migrar de plano',
                      cancelButtonText: 'Entendi',
                      focusCancel: true
                    }).then((res) => {
                      if(res.value) {
                        window.open(this.$router.resolve({ path: '/minha-assinatura' }).href);
                      }
                    })
                  }
                  else {
                    await this.$swal('Atenção', warningMessage + ' Fale com o gestor do seu consultório.', 'warning');
                  }
                  this.canPerformAction = true;
                  return false;
                }

                let doAction = true;

                let appointmentData = { agenda_id: this.agenda.value, type: this.appointmentForm.type == 'Agendamento'?'APPOINTMENT':'BLOCK' };
                if(this.appointmentForm.type == 'Agendamento') {
                    appointmentData.start_datetime = this.moment(this.appointmentForm.dateTime.startDate).format('YYYY-MM-DD')+' '+this.appointmentForm.startTime.format('HH:mm:ss');
                    appointmentData.end_datetime = this.moment(this.appointmentForm.dateTime.startDate).format('YYYY-MM-DD')+' '+this.appointmentForm.endTime.format('HH:mm:ss');
                    appointmentData.professional_id = this.appointmentForm.professional.value;
                    appointmentData.appointment_type_id = this.appointmentForm.appointmentType.value;
                    appointmentData.appointment_format_id = this.appointmentForm.appointmentFormat.value;
                    appointmentData.health_plan_id = this.appointmentForm.healthPlan.value;
                    appointmentData.notes = this.appointmentForm.notes;
                    appointmentData.patient = this.appointmentForm.patient;
                    appointmentData.patient.id = (this.appointmentForm.patient.id != null)?this.appointmentForm.patient.id:null;
                    appointmentData.telehealth = sentTelehealthLink;
                    appointmentData.telehealth_spectators = [];
                    if(appointmentData.telehealth && this.user.person.client.enable_multi_professional_telehealth_attendance) {
                      appointmentData.telehealth_spectators = this.appointmentForm.telehealthAttendanceSpectators.filter(professional => (professional.value !== appointmentData.professional_id)).map(professional => {
                        return professional.value;
                      });
                    }
                    appointmentData.send_sms = this.appointmentForm.send_sms;
                    appointmentData.send_whatsapp = this.appointmentForm.send_whatsapp;
                    appointmentData.to_anticipate = this.appointmentForm.to_anticipate;
                } else {
                    appointmentData.start_datetime = this.moment(this.appointmentForm.dateTime.startDate).format('YYYY-MM-DD HH:mm:ss');
                    appointmentData.end_datetime = this.moment(this.appointmentForm.dateTime.endDate).format('YYYY-MM-DD HH:mm:ss');
                    appointmentData.name = this.appointmentForm.name;
                }

                if(type != null) {
                    switch (type) {
                        case 'confirm':
                            appointmentData.status = 'CONFIRMED';
                            break;
                        case 'cancel':
                            appointmentData.status = 'CANCELED';
                            appointmentData.hide = true;
                            break;
                        case 'miss':
                            appointmentData.status = 'MISSED';
                            break;
                        case 'show':
                            appointmentData.status = 'SHOWEDUP';
                            break;
                    }

                    doAction = false;
                    await this.$swal({
                      title: 'Você tem certeza?',
                      text: 'Esta ação não poderá ser desfeita!',
                      type: 'warning',
                      showCancelButton: true,
                      confirmButtonText: 'OK',
                      cancelButtonText: 'Cancelar',
                      focusCancel: true
                    }).then((res) => {
                      if(res.value) {
                        doAction = true;
                      }
                    });
                }

                if(doAction) {
                    if(this.appointmentForm.id == null) {
                        appointmentData.repeat = {
                            enabled: this.repeatForm.enabled && this.repeatForm.enabled.value
                        };

                        if(this.repeatForm.enabled && this.repeatForm.enabled.value)
                            appointmentData.repeat = {
                                enabled: this.repeatForm.enabled.value,
                                option: (this.repeatForm.option != null)?this.repeatForm.option.value:'day',
                                month: (this.repeatForm.month != null)?this.repeatForm.month.value:null,
                                interval: this.repeatForm.interval,
                                daysOfWeek: this.repeatForm.daysOfWeek,
                                end: (this.repeatForm.end != null)?this.repeatForm.end.value:null,
                                endValue: this.repeatForm.endValue
                            };

                        this.api.storeAppointment(appointmentData).then(res => {
                            if(this.leavingPage) {
                                return;
                            }
                            try {
                                this.canPerformAction = true;

                                if (res.status == 201) {
                                    this.getAgenda();
                                    this.$bvModal.hide('appointment-modal');
                                } else {
                                    this.$swal('Ops...', 'Ocorreu um erro ao salvar o agendamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                                }
                            } catch(err) {
                                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: storeAppointment\nError:'+err.toString(), 'warning');
                                this.sentry.captureException(err);
                            }

                            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                                console.log('Response Store Appointment', res);
                        }).catch(err => {
                            if(this.leavingPage) {
                                return;
                            }
                            try {
                                this.canPerformAction = true;

                                let msg = 'Não conseguimos salvar este agendamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

                                if (typeof err.response != 'undefined')
                                    switch (err.response.status) {
                                        case 400:
                                            msg = err.response.data.message;
                                            break;
                                        case 422:
                                            msg = err.response.data.errors.join('\r\n');
                                            break;
                                    }

                                this.$swal('Ops...', msg, 'error');
                            } catch(err2) {
                                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchStoreAppointment\nError:'+err.toString(), 'warning');
                                this.sentry.captureException(err);
                            }

                            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                                console.log('Error Store Appointment', err);
                        });
                    } else {
                        this.api.updateAppointment(this.appointmentForm.id, appointmentData).then(res => {
                            if(this.leavingPage) {
                                return;
                            }
                            try {
                                this.canPerformAction = true;

                                if (res.status == 200) {
                                    this.getAgenda();
                                    this.$bvModal.hide('appointment-modal');
                                } else {
                                    this.$swal('Ops...', 'Ocorreu um erro ao atualizar o agendamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                                }
                            } catch (err) {
                                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: updateAppointment\nError:'+err.toString(), 'warning');
                                this.sentry.captureException(err);
                            }

                            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                                console.log('Response Update Appointment', res);
                        }).catch(err => {
                            if(this.leavingPage) {
                                return;
                            }
                            try {
                                this.canPerformAction = true;

                                let msg = 'Não conseguimos atualizar este agendamento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

                                switch (err.response.status) {
                                    case 400:
                                        msg = err.response.data.message;
                                        break;
                                    case 422:
                                        msg = err.response.data.errors.join('\r\n');
                                        break;
                                }

                                this.$swal('Ops...', msg, 'error');
                            } catch(err2) {
                                this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchUpdateAppointment\nError:'+err.toString(), 'warning');
                                this.sentry.captureException(err);
                            }

                            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                                console.log('Error Update Appointment', err);
                        });
                    }
                }
            },

            handleEventRender(info) {
              let eventInfo = info.event;
              let appointmentInfo = eventInfo.extendedProps.appointment;

              if(eventInfo.id != "" && appointmentInfo.type == 'APPOINTMENT') {
                let start = this.moment(eventInfo.start);
                let end = this.moment(eventInfo.end);
                let professionalHtml = '',
                  appointmentTypeHtml = '',
                  healthPlanHtml = '';
                let hasCalendarPreferences = this.agenda.calendar_preferences !== null;
                if((!hasCalendarPreferences || this.agenda.calendar_preferences.show_professional_on_calendar == 1) && appointmentInfo.professional != null) {
                  professionalHtml = '   <div class="fc-time"><i class="fa fa-circle mr-1" style="color:' + appointmentInfo.professional.indicator_color + '"></i>' + appointmentInfo.professional.name + '</div>';
                }
                if(!hasCalendarPreferences || this.agenda.calendar_preferences.show_appointment_type_on_calendar == 1) {
                  appointmentTypeHtml = '   <div class="fc-time">' + appointmentInfo.appointment_type.type + ' - ' + appointmentInfo.appointment_format.format + '</div>';
                }
                if(!hasCalendarPreferences || this.agenda.calendar_preferences.show_health_plan_on_calendar == 1) {
                  healthPlanHtml = '   <div class="fc-time">' + appointmentInfo.health_plan.name + (appointmentInfo.paid_invoice != null ? ' - PG ONLINE' : '') + '</div>';
                }

                info.el.innerHTML = '' +
                  '<div class="fc-content">' +
                  ' <div>' +
                  '   <div class="fc-title">' + eventInfo.title + '</div>' +
                  professionalHtml +
                  appointmentTypeHtml +
                  healthPlanHtml +
                  ' </div>' +
                  ' <div class="fc-time" data-start="' + start.format('HH:mm') + '" data-full="' + start.format('HH:mm') + ' - ' + end.format('HH:mm') + '">' +
                  '   <span>' + start.format('HH:mm') + ' - ' + end.format('HH:mm') + '</span>' +
                  ' </div>' +
                  '</div>';
              }
            },

            dateIsBefore(date1, date2) {
              let date = date1 instanceof Date ? this.moment(date1) : date1;
              return date.isBefore(date2);
            },
            formatPrice(value) {
              let val = (value/1).toFixed(2).replace('.', ',')
              return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
            },

            handleDateClick(arg) {
                let dateClicked = this.moment(arg.dateStr);
                let actualDate = this.moment();

                if(dateClicked.isAfter(actualDate)) {
                    let d = this.agendaConfig.slotDuration.split(':');
                    let minutes = parseInt(d[0] * 60) + parseInt(d[1]);

                    this.appointmentForm.date = this.moment(arg.date);
                    this.appointmentForm.dateTime = {
                        startDate: this.moment(arg.date),
                        endDate: this.moment(arg.date).add(minutes, 'minutes')
                    };
                    this.appointmentForm.startTime = this.moment(arg.date);
                    this.appointmentForm.endTime = this.moment(arg.date).add(minutes, 'minutes');
                    this.$bvModal.show('appointment-modal');
                } else {
                    this.$swal('Ops...', 'Não é possível realizar agendamentos em datas passadas!', 'error');
                }
            },

            async handleEventClick(info) {
                if(info.event.id != '') {
                    let today = this.moment().startOf('day');
                    let fourWeeksAgo = this.moment().startOf('day').subtract(4, 'week');
                    let eventStart = this.moment(info.event.start);

                    if((this.eventSelected == info.event.id || this.$attrs['isMobile'] || eventStart.isBefore(fourWeeksAgo)) && !info.event.classNames.includes('queue')) {
                      this.api.getAppointment(info.event.id).then(res => {
                        if(this.leavingPage) {
                            return;
                        }
                        let appointment = res.data;

                        this.appointmentForm = {
                          id: appointment.id,
                          type: (appointment.type == 'APPOINTMENT') ? 'Agendamento' : 'Bloqueio',
                          date: this.moment(appointment.start_datetime),
                          dateTime: {
                            startDate: this.moment(appointment.start_datetime),
                            endDate: this.moment(appointment.end_datetime)
                          },
                          startTime: this.moment(appointment.start_datetime.substr(-8, 5), 'HH:mm'),
                          endTime: this.moment(appointment.end_datetime.substr(-8, 5), 'HH:mm'),
                          professional: (appointment.professional != null) ? {
                            value: appointment.professional.id,
                            name: appointment.professional.name,
                            health_plans: appointment.professional.health_plans.map(healthPlan => { return { 'value': healthPlan.id, 'name': healthPlan.name } })
                          } : null,
                          telehealthAttendanceSpectators: [],
                          appointmentType: (appointment.appointment_type != null) ? {
                            value: appointment.appointment_type.id,
                            name: appointment.appointment_type.type
                          } : null,
                          appointmentFormat: (appointment.appointment_format != null) ? {
                            value: appointment.appointment_format.id,
                            name: appointment.appointment_format.format
                          } : null,
                          name: appointment.name,
                          patient: {
                            id: (appointment.patient != null) ? appointment.patient.id : null,
                            new: false,
                            name: (appointment.patient != null) ? appointment.patient.name : '',
                            internal_code: (appointment.patient != null) ? appointment.patient.internal_code : '',
                            email: (appointment.patient != null) ? appointment.patient.email : '',
                            birthday: (appointment.patient != null && appointment.patient.birthday != null && this.moment(appointment.patient.birthday).isValid()) ? this.moment(appointment.patient.birthday).format('DD/MM/YYYY') : '',
                            telephone: (appointment.patient == null) ? '' : (appointment.patient.cellphone != null) ? appointment.patient.cellphone : (appointment.patient.telephone != null) ? appointment.patient.telephone : '',
                            card_number: (appointment.patient == null) ? '' : (appointment.patient.card_number != null) ? appointment.patient.card_number : (appointment.patient.card_number != null) ? appointment.patient.card_number : '',
                            responsible_name: (appointment.patient != null) ? appointment.patient.responsible_name : '',
                            responsible_document: (appointment.patient != null) ? appointment.patient.responsible_document : '',
                            responsible_kinship: (appointment.patient != null) ? appointment.patient.responsible_kinship : '',
                            responsible_email: (appointment.patient != null) ? appointment.patient.responsible_email : '',
                            responsible_phone: (appointment.patient != null) ? appointment.patient.responsible_phone : '',
                            responsible_notes: (appointment.patient != null) ? appointment.patient.responsible_notes : '',
                            responsible2_name: (appointment.patient != null) ? appointment.patient.responsible2_name : '',
                            responsible2_document: (appointment.patient != null) ? appointment.patient.responsible2_document : '',
                            responsible2_kinship: (appointment.patient != null) ? appointment.patient.responsible2_kinship : '',
                            responsible2_email: (appointment.patient != null) ? appointment.patient.responsible2_email : '',
                            responsible2_phone: (appointment.patient != null) ? appointment.patient.responsible2_phone : '',
                            responsible2_notes: (appointment.patient != null) ? appointment.patient.responsible2_notes : '',
                          },
                          healthPlan: (appointment.health_plan != null) ? {
                            value: appointment.health_plan.id,
                            name: appointment.health_plan.name
                          } : null,
                          notes: appointment.notes,
                          send_telehealth_link: (appointment.telehealth),
                          send_sms: (appointment.send_sms),
                          send_whatsapp: (appointment.send_whatsapp),
                          to_anticipate: (appointment.to_anticipate),
                          status: appointment.status,
                          paid_invoice: appointment.paid_invoice,
                          telehealth_attendance: appointment.telehealth_attendance && appointment.telehealth_attendance.deleted_at == null ? appointment.telehealth_attendance : null,
                          repeat_id: appointment.repeat_id
                        };
                        if(appointment.telehealth_attendance && this.user.person.client.enable_multi_professional_telehealth_attendance && appointment.telehealth_attendance.spectators) {
                          appointment.telehealth_attendance.spectators.forEach(professional => {
                            this.appointmentForm.telehealthAttendanceSpectators.push({value: professional.id, name: professional.name});
                          });
                        }
                        this.$bvModal.show('appointment-modal');
                        this.$forceUpdate();

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                          console.log('Response Appointment', res);
                      }).catch(err => {
                        if(this.leavingPage) {
                            return;
                        }
                        this.$swal('Ops...', 'Não conseguimos carregar este agendamento/bloqueio! Por favor, entre em contato com o suporte!', 'error');
                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                          console.log('Error Appointment', err.response);
                      });
                    } else if(this.eventSelected == info.event.id && info.event.classNames.includes('queue')) {
                      this.removeEventSelection();
                    } else {
                        this.eventSelected = (this.eventSelected != info.event.id)?info.event.id:null;
                        let event = await this.$refs.agenda.getApi().getEventById(info.event.id);
                        await event.setProp('classNames', [...event.classNames, 'selected']);

                        // let contentAttr = document.querySelectorAll('.box-fullcalendar')[0].getBoundingClientRect();
                        let contentAttr = document.querySelectorAll('.fc-view-container')[0].getBoundingClientRect();
                        let elementAttr = document.querySelectorAll('.fc-event.selected')[0].getBoundingClientRect();

                        let divClass = [];

                        if(this.currentView == 'day') {
                          divClass.push('day');
                        }
                        else if(elementAttr.right + 150 >= contentAttr.right) {
                          divClass.push('left');
                        }

                        if(elementAttr.top + 205 >= contentAttr.bottom) {
                          divClass.push('bottom');
                        }

                        if(this.$attrs['isMobile']) {
                          divClass.push('mobile');
                        }

                        let isAppointment = info.event.classNames.includes('appointment'),
                            isTelehealth = isAppointment && this.helpers.planHasPermission('telehealth') && typeof event != 'undefined' && typeof event.extendedProps != 'undefined' && typeof event.extendedProps.appointment != 'undefined' && event.extendedProps.appointment.telehealth,
                            canStartAttendance = isAppointment && this.user.person.type == 'PROFESSIONAL' && typeof event != 'undefined' && typeof event.extendedProps != 'undefined' && typeof event.extendedProps.appointment != 'undefined' && event.extendedProps.appointment.professional.id == this.user.person.id,
                            canSpectateTelehealthAttendance = isTelehealth && this.user.person.type == 'PROFESSIONAL' && !canStartAttendance && this.user.person.client.enable_multi_professional_telehealth_attendance;

                        let quickActionList = '<div id="quickActionList" class="'+divClass.join(' ')+'">' +
                          '<ul>';

                        if(this.agenda.can_manage && !info.event.classNames.includes('attended')) {
                            quickActionList += (isAppointment || info.event.classNames.includes('block')) ? ('<li class="edit" data-type="multiple"><i class="far fa-edit"></i> Editar' + (isAppointment ? ' agendamento' : '') + '</li>') : '';
                            quickActionList += isAppointment ? '<li class="patient" data-type="multiple"><i class="far fa-address-card"></i> Ficha do Paciente</li>' : '';
                            quickActionList += isAppointment ? '<li class="edit-patient" data-type="multiple"><i class="far fa-user-edit"></i> Cadastro do Paciente</li>' : '';
                            quickActionList += isAppointment && (info.event.classNames.includes('scheduled') || info.event.classNames.includes('confirmed') || info.event.classNames.includes('showedup') || info.event.classNames.includes('attended') || info.event.classNames.includes('finished')) && (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'PROFESSIONAL' || this.helpers.checkPermission('attendance-guides', 'can_add', true)) ? '<li class="attendance-guide" data-type="multiple"><i class="far fa-file-medical"></i> Gerar guia</li>' : '';
                            quickActionList += (eventStart.isSameOrAfter(today) && isAppointment && (info.event.classNames.includes('showedup') || (isTelehealth && info.event.classNames.includes('confirmed'))) && canStartAttendance) ? ('<li class="start-attendance" data-type="appointment"><i class="far fa-play-circle"></i> Iniciar atendimento' + (isTelehealth ? ' online' : '') + '</li>') : '';
                            quickActionList += (eventStart.isSameOrAfter(today) && isAppointment && isTelehealth && (info.event.classNames.includes('confirmed') || info.event.classNames.includes('showedup')) && canSpectateTelehealthAttendance) ? ('<li class="spectate-attendance" data-type="appointment"><i class="far fa-play-circle"></i> Acompanhar atendimento online</li>') : '';
                            quickActionList += (eventStart.isSameOrAfter(today) && isAppointment && info.event.classNames.includes('scheduled')) ? '<li class="confirm" data-type="appointment"><i class="fal fa-calendar-check"></i> Confirmar</li>' : '';
                            quickActionList += ((eventStart.isSameOrAfter(today) || eventStart.isBetween(fourWeeksAgo, today)) && !info.event.classNames.includes('changed_status_after_date') && isAppointment && (info.event.classNames.includes('scheduled') || info.event.classNames.includes('confirmed'))) ? '<li class="cancel" data-type="appointment"><i class="fal fa-calendar-times"></i> Cancelar</li>' : '';
                            quickActionList += (eventStart.isSameOrAfter(today) && isAppointment && info.event.classNames.includes('canceled')) ? '<li class="hide" data-type="appointment"><i class="fal fa-eye-slash"></i> Esconder</li>' : '';
                            quickActionList += (info.event.classNames.includes('block')) ? '<li class="cancel" data-type="block"><i class="fal fa-calendar-times"></i> Remover</li>' : '';
                            quickActionList += ((eventStart.isSame(today, 'day') || eventStart.isBetween(fourWeeksAgo, today)) && !info.event.classNames.includes('changed_status_after_date') && isAppointment && (info.event.classNames.includes('scheduled') || info.event.classNames.includes('confirmed') || info.event.classNames.includes('missed'))) ? '<li class="showup" data-type="appointment"><i class="fal fa-calendar-check"></i> Compareceu</li>' : '';
                            quickActionList += (this.user.person.client.directing_enabled && eventStart.isSame(today, 'day') && isAppointment && !info.event.classNames.includes('has_directing') && (info.event.classNames.includes('showedup') || info.event.classNames.includes('attended') || info.event.classNames.includes('finished'))) ? '<li class="direct" data-type="appointment"><i class="fal fa-directions"></i> Encaminhar</li>' : '';
                            quickActionList += ((eventStart.isSame(today, 'day') || eventStart.isBetween(fourWeeksAgo, today)) && !info.event.classNames.includes('changed_status_after_date') && isAppointment && (info.event.classNames.includes('scheduled') || info.event.classNames.includes('confirmed') || info.event.classNames.includes('showedup'))) ? '<li class="miss" data-type="appointment"><i class="fal fa-calendar-times"></i> Faltou</li>' : '';
                            quickActionList += (info.event.classNames.includes('queue')) ? '<li class="cancel" data-type="appointment"><i class="fal fa-calendar-times"></i> Cancelar Fila</li>' : '';
                        } else {
                            quickActionList += (isAppointment || info.event.classNames.includes('block')) ? '<li class="edit" data-type="multiple"><i class="far fa-eye"></i> Visualizar</li>' : '';
                            quickActionList += isAppointment ? '<li class="patient" data-type="multiple"><i class="far fa-address-card"></i> Ficha do Paciente</li>' : '';
                            quickActionList += isAppointment ? '<li class="edit-patient" data-type="multiple"><i class="far fa-user-edit"></i> Cadastro do Paciente</li>' : '';
                            quickActionList += isAppointment && (info.event.classNames.includes('scheduled') || info.event.classNames.includes('confirmed') || info.event.classNames.includes('showedup') || info.event.classNames.includes('attended') || info.event.classNames.includes('finished')) && (this.helpers.isOwner() || this.user.person.type == 'SECRETARY' || this.user.person.type == 'PROFESSIONAL' || this.helpers.checkPermission('attendance-guides', 'can_add', true)) ? '<li class="attendance-guide" data-type="multiple"><i class="far fa-file-medical"></i> Gerar guia</li>' : '';
                            quickActionList += (eventStart.isSameOrAfter(today) && isAppointment && (info.event.classNames.includes('showedup') || (isTelehealth && info.event.classNames.includes('confirmed'))) && canStartAttendance) ? ('<li class="start-attendance" data-type="appointment"><i class="far fa-play-circle"></i> Iniciar atendimento' + (isTelehealth ? ' online' : '') + '</li>') : '';
                            quickActionList += (eventStart.isSameOrAfter(today) && isAppointment && isTelehealth && (info.event.classNames.includes('confirmed') || info.event.classNames.includes('showedup')) && canSpectateTelehealthAttendance) ? ('<li class="spectate-attendance" data-type="appointment"><i class="far fa-play-circle"></i> Acompanhar atendimento online</li>') : '';
                            quickActionList += (this.user.person.client.directing_enabled && eventStart.isSame(today, 'day') && isAppointment && !info.event.classNames.includes('has_directing') && (info.event.classNames.includes('showedup') || info.event.classNames.includes('attended') || info.event.classNames.includes('finished'))) ? '<li class="direct" data-type="appointment"><i class="fal fa-directions"></i> Encaminhar</li>' : '';
                        }

                        quickActionList += '</ul>' +
                          '</div>';

                        document.querySelectorAll('.selected')[0].insertAdjacentHTML('beforeend', quickActionList);

                        let els = document.querySelectorAll('#quickActionList > ul > li');

                        els.forEach(el => {
                            el.addEventListener('click', (event) => {
                                if(el.className != 'edit')
                                    event.stopPropagation();

                                this.callQuickAction(el.className, el.getAttribute('data-type'));
                            });
                        });
                    }
                }
            },

            handleEventDrop(event) {
              console.log('Event Drag Stop', event);
            },

            updateStartTime(value) {
                let v = (value.length == 5)?this.moment(value, 'HH:mm'):value;
                this.appointmentForm.startTime = v;
            },

            updateEndTime(value) {
                let v = (value.length == 5)?this.moment(value, 'HH:mm'):value;
                this.appointmentForm.endTime = v;
            },

            getCurrentLabel() {
                let agendaApi = this.$refs.agenda.getApi();
                let view = agendaApi.view;
                let startDate = this.moment(view.currentStart);
                let endDate = this.moment(view.currentEnd).subtract(1, 'days');

                this.currentDate = startDate;

                this.currentLabel = startDate.format('dddd, DD [de] MMMM [de] YYYY');

                if(!this.$attrs['isMobile']) {
                    if (this.currentView == 'month') {
                        this.currentLabel = startDate.format('MMMM [de] YYYY');
                    } else if (this.currentView == 'week') {
                        this.currentLabel = startDate.format('DD [de] MMMM') + ' até ' + endDate.format('DD [de] MMMM');
                    }
                }
            },

            newPatient() {
                this.appointmentForm.patient.name = this.$refs.multiselectPatient.search;
                this.appointmentForm.patient.new = true;
            },

            previousWeek() {
                let agendaApi = this.$refs.agenda.getApi();
                agendaApi.prev();

                this.getCurrentLabel();
                this.getAgenda();
            },

            nextWeek() {
                let agendaApi = this.$refs.agenda.getApi();
                agendaApi.next();

                this.getCurrentLabel();
                this.getAgenda();
            },

            async today() {
                this.firstDay = parseInt(this.moment().format('d'));

                let agendaApi = await this.$refs.agenda.getApi();
                agendaApi.gotoDate(this.moment().format('YYYY-MM-DD'));

                this.currentRange = { startDate: this.moment(), endDate: this.moment().add(6, 'days') };
                this.getCurrentLabel();
                this.getAgenda();
            },

            async dateRangePickerAgendaUpdated(date) {
                let startDate = date.startDate;

                let agendaApi = await this.$refs.agenda.getApi();
                agendaApi.gotoDate(this.moment(startDate).format('YYYY-MM-DD'));

                if(!this.moment(date.startDate).isSame(this.moment(date.endDate))) {
                    this.firstDay = parseInt(this.moment(startDate).format('d'));

                    agendaApi.firstDay = await this.moment(startDate).format('d');
                    agendaApi.changeView('timeGridWeek');
                } else {
                    this.firstDay = parseInt(this.moment().format('d'));

                    agendaApi.firstDay = await this.moment().format('d');
                }

                this.getCurrentLabel();
                this.getAgenda();
            },

            async dateRangePickerAgendaMonthChanged(date) {
                let startDate = this.moment(date).startOf('month');
                let endDate = this.moment(date).endOf('month');

                if(this.lastDateRangePickerAgendaMonth == null || (this.lastDateRangePickerAgendaMonth != null && this.lastDateRangePickerAgendaMonth.startDate != startDate.format('DD/MM/YYYY') && this.lastDateRangePickerAgendaMonth.endDate != endDate.format('DD/MM/YYYY'))) {
                    this.lastDateRangePickerAgendaMonth = {
                        startDate: startDate.format('DD/MM/YYYY'),
                        endDate: endDate.format('DD/MM/YYYY')
                    }

                    this.getDatesClasses(startDate, endDate);
                }
            },

            async dateRangePickerAgendaToggle(open) {
                if(open)
                    this.getDatesClasses(this.moment(this.currentRange.startDate).startOf('month'), this.moment(this.currentRange.startDate).endOf('month'));
            },

            async changeTime(time, action, quantity, interval) {
                this.appointmentForm.startTime = this.appointmentForm.startTime instanceof this.moment ? this.appointmentForm.startTime : this.moment(this.appointmentForm.startTime);
                this.appointmentForm.endTime = this.appointmentForm.endTime instanceof this.moment ? this.appointmentForm.endTime : this.moment(this.appointmentForm.endTime);
                let appointmentTime = (time == 'startTime')?this.appointmentForm.startTime:this.appointmentForm.endTime;


                if (action === 'add') {
                  appointmentTime = await appointmentTime.clone().add(quantity, interval);
                } else {
                  appointmentTime = await appointmentTime.clone().subtract(quantity, interval);
                }

                if((time == 'startTime' && this.appointmentForm.endTime.diff(appointmentTime, 'minutes') <= 0) || (time == 'endTime' && appointmentTime.diff(this.appointmentForm.startTime, 'minutes') <= 0)) {
                  return;
                }

                if(time == 'startTime') {
                    this.appointmentForm.startTime = appointmentTime;
                    this.appointmentForm.endTime.set({
                        'date': appointmentTime.get('date'),
                        'month': appointmentTime.get('month'),
                        'year': appointmentTime.get('year')
                    });
                } else {
                    this.appointmentForm.startTime.set({
                        'date': appointmentTime.get('date'),
                        'month': appointmentTime.get('month'),
                        'year': appointmentTime.get('year')
                    });
                    this.appointmentForm.endTime = appointmentTime;
                }

                this.$forceUpdate();
            },

            async changeView(view) {
                this.currentView = view;
                let agendaApi = await this.$refs.agenda.getApi();

                if(this.currentView == 'month') {
                    await agendaApi.changeView('dayGridMonth');
                } else if(this.currentView == 'week') {
                    await agendaApi.changeView('timeGridWeek');
                } else {
                    await agendaApi.changeView('timeGridDay');
                }

                let agendaApiView = agendaApi.view;
                let startDate = this.moment(agendaApiView.currentStart);
                let endDate = this.moment(agendaApiView.currentEnd).subtract(1, 'days');
                this.currentRange = { startDate: startDate, endDate: endDate };

                this.getCurrentLabel();
                this.getAgenda();
            },

            selectDay(date) {
                this.changeView('day');
                this.currentDate = this.moment(date);

                let agendaApi = this.$refs.agenda.getApi();
                agendaApi.changeView('timeGridDay', this.currentDate.format('YYYY-MM-DD'));
            },

            columnHeaderHtml(date) {
                date = this.moment(date);

                let header = '';
                if(date.isSame(this.moment(), 'day')) {
                    header = '<span class=\'d-block\'><b class=\'w-100\'><span>Hoje</span><br/><small>'+date.format('dddd')+'</small>';
                } else {
                    header = '<span class=\'d-block\'><b class=\'w-100\'>' + date.format('dddd') + '</b>';
                }

                if(this.currentView != 'month') {
                    header += '<br/><small class=\'w-100\'>' + date.format('DD/MM') + '</small></span>';
                } else {
                    header += '</span>';
                }

                return header
            },

            buildModalHeader() {
                if(typeof this.appointmentForm.dateTime == 'object' && this.appointmentForm.dateTime.startDate.constructor.name == 'Moment') {
                    if (this.appointmentForm.type == 'Agendamento') {
                        let startTime = (this.appointmentForm.startTime instanceof this.moment)?this.appointmentForm.startTime.format('HH:mm'):this.appointmentForm.startTime;
                        let endTime = (this.appointmentForm.endTime instanceof this.moment)?this.appointmentForm.endTime.format('HH:mm'):this.appointmentForm.endTime;
                        return this.moment(this.appointmentForm.dateTime.startDate).format('dddd, DD [de] MMMM') + ' - ' + startTime + ' até ' + endTime;
                    } else {
                        return this.moment(this.appointmentForm.dateTime.startDate).format('ddd, DD [de] MMM HH:mm') + ' até ' + this.moment(this.appointmentForm.dateTime.endDate).format('ddd, DD [de] MMM HH:mm');
                    }
                }
            },

            removeEventSelection() {
                let event = this.$refs.agenda.getApi().getEventById(this.eventSelected);
                if(event != null) {
                  let actualClasses = [...event.classNames];
                  actualClasses.pop('selected');
                  event.setProp('classNames', actualClasses);

                  this.eventSelected = null;
                  if (document.getElementById('quickActionList') != null)
                    document.getElementById('quickActionList').remove();
                } else {
                    this.eventSelected = null;
                }
            },

            async callQuickAction(action, type) {
              let event = await this.$refs.agenda.getApi().getEventById(this.eventSelected);
                if(action == 'patient') {
                    if(typeof event != 'undefined' && typeof event.extendedProps != 'undefined' && typeof event.extendedProps.appointment != 'undefined')
                        this.$router.push({path: '/pacientes/'+event.extendedProps.appointment.patient.id }).catch(() => {});
                  this.removeEventSelection();
                } else if(action == 'edit-patient') {
                  if(typeof event != 'undefined' && typeof event.extendedProps != 'undefined' && typeof event.extendedProps.appointment != 'undefined') {
                    let route = this.$router.resolve({path: '/pacientes/'+event.extendedProps.appointment.patient.id+'?editar=1' }).href;

                    window.open(route, '_blank');
                  }
                  this.removeEventSelection();
                } else if(action == 'attendance-guide') {
                  if(typeof event != 'undefined' && typeof event.extendedProps != 'undefined' && typeof event.extendedProps.appointment != 'undefined') {
                    this.attendanceGuideForm.appointment_id = this.eventSelected;
                    this.attendanceGuideForm.patient_id = event.extendedProps.appointment.patient.id;
                    this.attendanceGuideForm.name = event.extendedProps.appointment.patient.name;
                    let professional = this.professionals.find(professional => professional.value == event.extendedProps.appointment.professional.id);
                    this.attendanceGuideForm.professional = professional.name;
                    this.attendanceGuideForm.bill_type = this.helpers.planHasPermission('financial') ? null : this.billTypeOptions.find(g => g.value == 'full_guide');
                    this.attendanceGuideForm.is_dentist = professional.is_dentist;
                    this.attendanceGuideHealthPlans = this.getAttendanceGuideHealthPlans(event.extendedProps.appointment);
                    this.$bvModal.show('attendance-guide-modal');
                  }
                  this.removeEventSelection();
                } else if(action == 'confirm') {
                    await this.api.confirmAppointment(this.eventSelected).then(res => {
                        if(this.leavingPage) {
                            return;
                        }
                        this.$swal('Parabéns...', 'Agendamento confirmado com sucesso!', 'success');

                        this.getAppointments();
                        this.removeEventSelection();

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Response Confirm Appointment', res);
                    }).catch(err => {
                        if(this.leavingPage) {
                            return;
                        }
                        try {
                          this.removeEventSelection();

                          let response = err.response;
                          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos confirmar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                          this.$swal('Ops...', message, 'error');
                        } catch(err2) {
                          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchConfirmAppointment\nError:'+err.toString(), 'warning');
                          this.sentry.captureException(err);
                        }

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Error Confirm  Appointment', err.response);
                    });
                } else if(action == 'cancel') {
                    let doCancel = false;
                    let event = await this.$refs.agenda.getApi().getEventById(this.eventSelected);
                    let cancelType = 'this';

                    if(event.extendedProps.appointment.repeat_id != null) {
                      await this.$swal({
                        title: 'Excluir agendamento recorrente',
                        input: 'select',
                        inputOptions: {
                          this: 'Este agendamento',
                          future: 'Este e os agendamentos futuros',
                          all: 'Todos os agendamentos'
                        },
                        showCancelButton: true,
                        cancelButtonText: 'Cancelar',
                        inputValidator: (value) => {
                          cancelType = value;
                        }
                      }).then((res) => {
                        if(res.value) {
                          doCancel = true;
                        }
                      });
                    }
                    else {
                      await this.$swal({
                        title: 'Você tem certeza?',
                        text: 'Esta ação não poderá ser desfeita!',
                        type: 'warning',
                        showCancelButton: true,
                        confirmButtonText: 'OK',
                        cancelButtonText: 'Cancelar',
                        focusCancel: true
                      }).then((res) => {
                        if(res.value) {
                          doCancel = true;
                        }
                      });
                    }

                    if(doCancel) {
                        await this.api.cancelAppointment(this.eventSelected, cancelType).then(res => {
                            if(this.leavingPage) {
                                return;
                            }
                            this.$swal('Parabéns...', (type == 'appointment')?'Agendamento cancelado com sucesso!':'Bloqueio removido com sucesso!', 'success');

                            this.getAppointments();
                            this.removeEventSelection();

                            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                                console.log('Response Cancel Appointment', res);
                        }).catch(err => {
                            if(this.leavingPage) {
                                return;
                            }
                            try {
                              this.removeEventSelection();

                              let response = err.response;
                              let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos cancelar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                              this.$swal('Ops...', message, 'error');

                            } catch(err2) {
                              this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchCancelAppointment\nError:'+err.toString(), 'warning');
                              this.sentry.captureException(err);
                            }

                            if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                              console.log('Error Cancel  Appointment', err.response);
                        });
                    }
                } else if(action == 'hide') {
                    await this.api.hideAppointment(this.eventSelected).then(res => {
                        if(this.leavingPage) {
                            return;
                        }
                        this.$swal('Parabéns...', 'Agendamento escondido com sucesso!', 'success');

                        this.getAppointments();
                        this.removeEventSelection();

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Response Hide Appointment', res);
                    }).catch(err => {
                        if(this.leavingPage) {
                            return;
                        }
                        try {
                          this.removeEventSelection();

                          let response = err.response;
                          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos esconder este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                          this.$swal('Ops...', message, 'error');
                        } catch(err2) {
                          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchHideAppointment\nError:'+err.toString(), 'warning');
                          this.sentry.captureException(err);
                        }

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Error Hide Appointment', err.response);
                    });
                } else if(action == 'showup') {
                    await this.api.showupAppointment(this.eventSelected).then(res => {
                        if(this.leavingPage) {
                            return;
                        }
                        this.$swal('Parabéns...', 'Presença registrada com sucesso!', 'success');

                        this.getAppointments();
                        this.removeEventSelection();

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Response Show Up Appointment', res);
                    }).catch(err => {
                        if(this.leavingPage) {
                            return;
                        }
                        try {
                          this.removeEventSelection();

                          let response = err.response;
                          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos confirmar este agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                          this.$swal('Ops...', message, 'error');
                        } catch(err2) {
                          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchShowupAppointment\nError:'+err.toString(), 'warning');
                          this.sentry.captureException(err);
                        }

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                          console.log('Error Show Up Appointment', err.response);
                    });
                } else if(action == 'direct') {
                  if(typeof event != 'undefined' && typeof event.extendedProps != 'undefined' && typeof event.extendedProps.appointment != 'undefined') {
                    this.directingForm.appointment_id = this.eventSelected;
                    this.$bvModal.show('directing-modal');
                  }
                  this.removeEventSelection();
                } else if(action == 'miss') {
                    await this.api.missAppointment(this.eventSelected).then(res => {
                        if(this.leavingPage) {
                            return;
                        }
                        this.$swal('Parabéns...', 'Falta registrada com sucesso!', 'success');

                        this.getAppointments();
                        this.removeEventSelection();

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Response Miss Appointment', res);
                    }).catch(err => {
                        if(this.leavingPage) {
                           return;
                        }
                        try {
                          this.removeEventSelection();
                          let response = err.response;
                          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos registrar a falta neste agendamento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                          this.$swal('Ops...', message, 'error');
                        } catch(err2) {
                          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchMissAppointment\nError:'+err.toString(), 'warning');
                          this.sentry.captureException(err);
                        }

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                          console.log('Error Miss Appointment', err.response);
                    });
                } else if(action == 'start-attendance') {
                    await this.api.startAttendanceAppointment(this.eventSelected).then(res => {
                        if(this.leavingPage) {
                           return;
                        }
                        if(res.status == 201) {
                          let attendanceData = res.data;
                          if(attendanceData.appointment.telehealth && attendanceData.telehealth_attendance != null) {
                            window.open(this.$router.resolve({path: '/pacientes/'+attendanceData.patient_id+'/teleconsulta/'+attendanceData.telehealth_attendance.id}).href);
                            this.removeEventSelection();
                          }
                          else {
                            this.$router.push({path: '/pacientes/'+res.data.patient_id }).catch(() => {});
                          }

                            // this.eventBus.$emit('ATTENDANCE_STARTED', res.data);
                        }

                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                            console.log('Response Start Attendance Appointment', res);
                    }).catch(err => {
                        if(this.leavingPage) {
                            return;
                        }
                        try {
                          this.removeEventSelection();
                          let response = err.response;
                          let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos iniciar este atendimento! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                          this.$swal('Ops...', message, 'error');
                        } catch(err2) {
                          this.$swal('Erro', 'Por favor tire um print / foto e envie para nosso suporte:\n\nMethod: catchStartAttendance\nError:'+err.toString(), 'warning');
                          this.sentry.captureException(err);
                        }
                        if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                          console.log('Error Start Attendance  Appointment', err.response);
                    });
                } else if(action == 'spectate-attendance') {
                  if(typeof event != 'undefined' && typeof event.extendedProps != 'undefined' && typeof event.extendedProps.appointment != 'undefined') {
                    let route = this.$router.resolve({path: '/pacientes/'+event.extendedProps.appointment.patient.id+'/acompanhar-teleconsulta/'+this.eventSelected }).href;
                    window.open(route, '_blank');
                  }
                  this.removeEventSelection();
                }
            },


            resetAttendanceGuideModal() {
              this.attendanceGuideForm = {
                id: null,
                appointment_id: null,
                patient_id: '',
                name: '',
                professional: '',
                bill_type: null,
                is_dentist: false,
                healthPlan: null,
                // title: '',
                // professional: null,
                // status: '',
                items: [],
                item: {
                  tooth: null,
                  faces: null,
                  procedure: null,
                  amount: 1,
                  value: 0,
                  accomplished: false
                }
              };
            },

            resetDirectingModal() {
              this.directingForm = {
                appointment_id: null,
                directing_sector: null,
                professional: null
              };
            },

            sectorSelected(selectedOption) {
              let agendaProfessionals = this.professionals.map(professional => professional.value);
              this.directingSectorProfessionalOptions = this.directingSectorProfessionals[selectedOption.value].filter(professional => agendaProfessionals.indexOf(professional.value) >= 0).sort((a, b) => a.name.localeCompare(b.name));
              if(this.directingForm.professional != null && !this.directingSectorProfessionalOptions.find(professional => professional.value == this.directingForm.professional.value)) {
                this.directingForm.professional = null;
              }
            },

            getProfessionalHealthPlans() {
                let health_plans = [];

                if(this.appointmentForm.professional != null && typeof this.appointmentForm.professional.health_plans != 'undefined')
                    health_plans = this.appointmentForm.professional.health_plans;

                return health_plans;
            },

            getAttendanceGuideHealthPlans(appointment) {
              let health_plans = [];

              if(appointment.professional != null) {
                let professional = this.professionals.find(professional => professional.value == appointment.professional.id);
                if(professional != null && typeof professional.health_plans != 'undefined') {
                  professional.health_plans.forEach(healthPlan => {
                    if(healthPlan.value === appointment.health_plan.id || healthPlan.name === 'Particular') {
                      health_plans.push(healthPlan);
                    }
                  });
                }
              }

              return health_plans;
            },

            findAttendanceGuideProcedures(query) {
              this.attendanceGuideProcedures = [];
              if(query.length >= 3 && !this.isLoadingAttendanceGuideProcedures) {
                if(this.findAttendanceGuideProceduresTimer !== null) {
                  clearTimeout(this.findAttendanceGuideProceduresTimer);
                }
                this.findAttendanceGuideProceduresTimer = setTimeout(() => {
                  this.isLoadingAttendanceGuideProcedures = true;
                  this.api.getProcedures({ term: query }).then(res => {
                    if(this.leavingPage) {
                        return;
                    }
                    this.isLoadingAttendanceGuideProcedures = false;

                    this.attendanceGuideProcedures = res.data.data.map(procedure => {
                      return { value: procedure.id, name: procedure.name, procedure_value: procedure.value, cnae: procedure.cnae };
                    });
                  }).catch(err => {
                    if(this.leavingPage) {
                        return;
                    }
                    if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                      console.log('Error AttendanceGuideProcedures', err.response);
                  });
                }, 300);
              }
            },

            async addItemToAttendanceGuide() {
              if(!this.canPerformAction)
                return false;

              this.canPerformAction = false;

              const isValid = await this.$refs.attendanceGuideItemForm.validate();
              if(!isValid) {
                this.canPerformAction = true;
                return false;
              }

              let item = this.attendanceGuideForm.item;
              if(item.faces != null) {
                item.faces = item.faces.join(', ');
              }
              this.attendanceGuideForm.items.push(item);

              this.attendanceGuideForm.item = {
                tooth: null,
                faces: null,
                procedure: null,
                amount: 1,
                value: 0,
                accomplished: false
              };

              this.$refs.attendanceGuideItemForm.reset();
              this.canPerformAction = true;
            },

            async removeItemFromAttendanceGuide(index) {
              this.attendanceGuideForm.items.splice(index, 1);
            },

            async billAttendanceGuide() {
              if(!this.canPerformAction)
                return false;

              const isValid = await this.$refs.attendanceGuideForm.validate();
              if(!isValid) {
                return false;
              }
              if(this.attendanceGuideForm.items.length === 0) {
                this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
                return false;
              }
              if(this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null).length === 0) {
                this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
                return false;
              }

              if(this.user.person.client.enable_mandic_nf) {
                let items = this.attendanceGuideForm.items,
                    cnaes = [];
                if(this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
                  items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
                }
                items.forEach(item => {
                  if(cnaes.indexOf(item.procedure.cnae) === -1) {
                    cnaes.push(item.procedure.cnae);
                  }
                });
                if(cnaes.length > 1) {
                  this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
                  return false;
                }
              }

              this.attendanceGuideForm.authorization_code = '';

              if(this.attendanceGuideForm.health_plan.name !== 'Particular') {
                let { value: authorizationCode } = await this.$swal({
                  title: 'N° de Autorização de Guia de Atendimento',
                  text: 'Informe o número de autorização para faturamento desta guia',
                  input: 'text',
                  inputLabel: 'Número de autorização',
                  inputAttributes: {
                    maxlength: 100,
                  },
                  showCancelButton: true,
                  cancelButtonText: 'Cancelar',
                  inputValidator: (value) => {
                    if (!value) {
                      return 'Você tem que preencher o número de autorização!'
                    }
                  }
                });
                if(authorizationCode) {
                  this.attendanceGuideForm.authorization_code = authorizationCode;
                  this.saveAttendanceGuide(true);
                }
              }
              else {
                this.saveAttendanceGuide(true);
              }
            },

            async saveAttendanceGuide(bill) {
              if(!this.canPerformAction)
                return false;

              this.canPerformAction = false;

              const isValid = await this.$refs.attendanceGuideForm.validate();
              if(!isValid) {
                this.canPerformAction = true;
                return false;
              }
              if(this.attendanceGuideForm.items.length === 0) {
                this.canPerformAction = true;
                this.$swal('Ops...', 'Você precisa adicionar ao menos um procedimento para salvar a guia de atendimento!', 'error');
                return false;
              }
              if(bill && this.attendanceGuideForm.bill_type.value === 'accomplished_procedures' && this.attendanceGuideForm.items.filter(item => item.accomplished).length === 0) {
                this.canPerformAction = true;
                this.$swal('Ops...', 'Só é possível faturar a guia de atendimento se ao menos um procedimento tiver sido realizado!', 'error');
                return false;
              }

              if(bill && this.user.person.client.enable_mandic_nf) {
                let items = this.attendanceGuideForm.items,
                    cnaes = [];
                if(this.attendanceGuideForm.bill_type.value === 'accomplished_procedures') {
                  items = items.filter(item => item.accomplished && item.attendance_guide_invoice_id == null);
                }
                items.forEach(item => {
                  if(cnaes.indexOf(item.procedure.cnae) === -1) {
                    cnaes.push(item.procedure.cnae);
                  }
                });
                if(cnaes.length > 1) {
                  this.$swal('Ops...', 'Procedimentos de CNAEs diferentes devem ser faturados separadamente.', 'error');
                  return false;
                }
              }

              let attendanceGuideData = {
                health_plan_id: this.attendanceGuideForm.health_plan.value,
                bill_type: this.attendanceGuideForm.bill_type.value,
                bill: bill,
                authorization_code: bill ? this.attendanceGuideForm.authorization_code : null,
                items: this.attendanceGuideForm.items.map(item => {
                  return {
                    procedure_id: item.procedure.value,
                    tooth: item.tooth,
                    faces: item.faces,
                    amount: item.amount,
                    value: item.value,
                    accomplished: item.accomplished
                  }
                })
              };

              await this.api.storeAttendanceGuide(this.attendanceGuideForm.appointment_id, attendanceGuideData).then(res => {
                if(this.leavingPage) {
                  return;
                }
                this.canPerformAction = true;

                if (res.status == 201) {
                  let patientId = this.attendanceGuideForm.patient_id;
                  this.$bvModal.hide('attendance-guide-modal');
                  if(bill) {
                    let transactionId = res.data.id;
                    this.$swal('Uhull \\o/', 'A guia de atendimento foi cadastrada com sucesso! Agora finalize o cadastro da fatura.', 'success').then(() => {
                      this.$router.push({path: '/financeiro/contas-a-receber/' + transactionId}).catch(() => {});
                    });
                  }
                  else {
                    this.$swal('Uhull \\o/', 'A guia de atendimento foi cadastrada com sucesso!', 'success').then(() => {
                      this.$router.push({path: '/pacientes/'+patientId}).catch(() => {});
                    });
                  }
                } else {
                  this.$swal('Ops...', 'Ocorreu um erro ao cadastrar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!', 'error');
                }

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Store Attendance Guide', res);
              }).catch(err => {
                if(this.leavingPage) {
                  return;
                }
                this.canPerformAction = true;

                let msg = 'Não conseguimos cadastrar esta guia de atendimento! Por favor, tente novamente. Caso o problema persista entre em contato com o suporte!';

                switch (err.response.status) {
                  case 422: msg = err.response.data.errors.join('\r\n'); break;
                }

                this.$swal('Ops...', msg, 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Store Attendance Guide', err.response);
              });
            },

            async saveDirecting() {
              if(!this.canPerformAction)
                return false;

              this.canPerformAction = false;

              const isValid = await this.$refs.directingForm.validate();
              if(!isValid) {
                this.canPerformAction = true;
                return false;
              }

              let directingData = {
                appointment_id: this.directingForm.appointment_id,
                professional_id: this.directingForm.professional != null ? this.directingForm.professional.value : null
              };

              await this.api.createDirecting(this.directingForm.directing_sector.value, directingData).then(res => {
                if(this.leavingPage) {
                  return;
                }
                this.canPerformAction = true;
                this.$swal('Parabéns...', 'Paciente encaminhado com sucesso!', 'success');

                this.getAppointments();
                this.$bvModal.hide('directing-modal');

                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Response Create Directing', res);
              }).catch(err => {
                if(this.leavingPage) {
                  return;
                }
                this.canPerformAction = true;

                let response = err.response;
                let message = (response.status == 400 && typeof response.data.message != 'undefined' && response.data.message != '')?response.data.message:'Não conseguimos encaminhar este paciente! Por favor, tente novamente. Caso o erro persista, entre em contato com o suporte!';

                this.$swal('Ops...', message, 'error');
                if (process.env.VUE_APP_SHOW_CONSOLE === 'true')
                  console.log('Error Create Directing', response);
              });
            },

            getStatusName(status) {
                switch (status) {
                    case 'SCHEDULED':
                        status = 'Agendado';
                        break;
                    case 'CONFIRMED':
                        status = 'Confirmado';
                        break;
                    case 'CANCELED':
                        status = 'Cancelado';
                        break;
                    case 'MISSED':
                        status = 'Faltou';
                        break;
                    case 'SHOWEDUP':
                        status = 'Compareceu';
                        break;
                    case 'ATTENDED':
                      status = 'Atendido';
                      break;
                    case 'FINISHED':
                        status = 'Finalizado';
                        break;
                    default:
                        status = 'Não identificado';
                        break;
                }

                return status;
            },

            print() {
                window.print();
            },

            toggleDow(dow) {
                if (this.repeatForm.daysOfWeek.includes(dow)) {
                    let index = this.repeatForm.daysOfWeek.indexOf(dow);
                    this.repeatForm.daysOfWeek.splice(index, 1);

                    // this.breaks = this.breaks.filter(brk => {
                    //     return brk.day_of_week != dow;
                    // })
                } else {
                    this.repeatForm.daysOfWeek.push(dow);
                    this.repeatForm.daysOfWeek.sort();
                }
            },

            repeatTypeSelected(selectedOption) {
                let date = this.appointmentForm.date.clone();

                if(selectedOption.value == 'month') {
                    let options = [ { value:'fixed-day', name:'Mensalmente no dia '+date.format('D')} ]

                    switch (Math.ceil(date.date() / 7)) {
                        case 1: options.push({ value:'fixed-week', name:'Mensalmente na primeira '+date.format('dddd').toLocaleLowerCase()+' do mês' }); break;
                        case 2: options.push({ value:'fixed-week', name:'Mensalmente na segunda '+date.format('dddd').toLocaleLowerCase()+' do mês' }); break;
                        case 3: options.push({ value:'fixed-week', name:'Mensalmente na terceira '+date.format('dddd').toLocaleLowerCase()+' do mês' }); break;
                        case 4: options.push({ value:'fixed-week', name:'Mensalmente na quarta '+date.format('dddd').toLocaleLowerCase()+' do mês' }); break;
                        case 5: options.push({ value:'fixed-week', name:'Mensalmente na última '+date.format('dddd').toLocaleLowerCase()+' do mês' }); break;
                    }

                    this.repeatMonthOptions = options;
                } else if(selectedOption.value == 'week') {
                    this.repeatForm.daysOfWeek.push(date.day());
                }
            },

            differenceToNow(date) {
                let now = this.moment();
                date = this.moment(date);

                return date.diff(now, 'hours');
            },

            nameWithInternalCode({ name, internal_code }) {
                if(internal_code != null && internal_code.length > 1 && internal_code != '') {
                    return name+' ('+internal_code+')';
                } else {
                    return name;
                }
            },

            sendTelehealthWhatsapp() {
              let message = "Link de acesso: " + this.aolUrl + "teleconsulta/" + this.appointmentForm.telehealth_attendance.id + "\n" +
                  "Código de acesso: *" + this.appointmentForm.telehealth_attendance.code + "*";
              window.open('https://wa.me/55'+this.appointmentForm.patient.telephone.replace(/\D/g, '')+'?text='+encodeURIComponent(message));
            }
        },
        beforeRouteLeave (to, from, next) {
            this.leavingPage = true;
            if(this.findPatientsTimer !== null) {
              clearTimeout(this.findPatientsTimer);
            }
            if(this.findAttendanceGuideProceduresTimer !== null) {
              clearTimeout(this.findAttendanceGuideProceduresTimer);
            }
            next();
        }
    }
</script>

<style lang="scss">
    @import '~@fullcalendar/core/main.css';
    @import '~@fullcalendar/daygrid/main.css';
    @import "~@fullcalendar/timegrid/main.css";

    .agenda {
        padding: 20px 0;

        #quickActionList {
            z-index: 1000000 !important;
            position: absolute;
            left: calc(100% + 5px);
            top: 0;

            &.day {
                left: unset;
                right: unset;

                top: calc(100% + 5px);
            }

            &.bottom {
                top: unset;
                bottom: 0;

                &.day {
                    bottom: calc(100% + 5px);
                }
            }

            &.left {
                left: unset;
                right: calc(100% + 50px);
            }

            &.mobile {
                left: 0;
                bottom: -110%;

                ul {
                    li {
                        padding: 5px;
                        font-size: 1.1em;
                    }
                }
            }

            ul {
                white-space: nowrap;
                margin-bottom: 0;

                li {
                    width: 100%;
                    padding: 5px 25px 5px 5px;
                    border-radius: 5px;
                    margin-bottom: 5px;
                    color: #ffffff;
                    transition: all 0.5s;
                    font-weight: normal !important;

                    &:last-child {
                        margin-bottom: 0;
                    }

                    i {
                        margin-right: 5px;
                    }

                    &.edit {
                        background-color: $curiousBlue;
                    }

                    &.start-attendance, &.patient {
                        background-color: #ffffff;
                        color: $curiousBlue;
                    }

                    &.edit-patient {
                        background-color: $athenGray1;
                        color: $curiousBlue;
                    }

                    &.spectate-attendance {
                        background-color: $cadetGray;
                        color: #ffffff;
                    }

                    &.attendance-guide {
                        background-color: $pictionBlue;
                    }

                    &.confirm {
                        background-color: $ufoGreen;
                    }

                    &.cancel, &.hide {
                        background-color: $dullRed;
                    }

                    &.miss {
                        background-color: $yellowSea;
                    }

                    &.showup {
                        background-color: $majorelleBlue;
                    }

                    &.direct {
                        background-color: $blueBayoux;
                    }

                    &:hover {
                        width: calc(100% - 15px);
                    }
                }
            }
        }

        .main-header {
            background-color: #f0f2f8;
            margin-bottom: 16px;
        }

        .title {
            font-size: 20px;
            color: $bunting;
        }

        .box-fullcalendar {
            background-color: #ffffff;
            border: 1px solid $mystic;
            border-radius: 4px;
            flex: 1;
            overflow: hidden;

            > div {
                padding: 0 20px 20px 20px;
                height: 100%;
                width: 100%;
                overflow-y: scroll;
                overflow-x: hidden;
                /*box-sizing: content-box;*/
            }

            .eventSelected {
                * {
                    z-index: auto !important;
                }

                .fc-head-container.fc-widget-header {
                    z-index: 100 !important;
                }
            }

            .fc-head > tr {
                z-index: 10;
            }

            .fc-day-header {
                padding: 20px 0;
                line-height: 14px;
                vertical-align: middle;
            }

            .fc-day-header.fc-today {
                background-color: $pictionBlue !important;
                color: #ffffff;
            }

            .fc-toolbar.fc-header-toolbar {
                margin-bottom: 0;
            }

            .fc-ltr .fc-time-grid .fc-event-container {
                margin: 0 10% 0 2px;
            }

            .fc-row table {
                border-bottom-style: none;
            }

            .fc-now-indicator {
                border-color: $dullRed;

                &.fc-now-indicator-arrow {
                    border-top-color: transparent;
                    border-bottom-color: transparent;
                }
            }

            .fc-event {
                font-family: 'sf_pro_displaymedium';
                background-color: #ffffff;
                color: $waikawaGray;
                padding: 0 5px;
                border: 1px solid $linkWater;
                cursor: pointer;
                transition: 0.5s all;
                display: flex;
                align-items: center;
                justify-content: left;

                &.block.scheduled {
                    border-top: 5px solid $linkWater;
                }

                &.queue.waiting {
                    opacity: 0.75;
                    border-top: 5px solid #dfdf00;
                    background: #ffff98;
                    
                    &:hover {
                        color: #000000;
                    }
                }

                &.appointment {
                    &.scheduled {
                        border-top: 5px solid $curiousBlue;
                    }

                    &.confirmed {
                        border-top: 5px solid $ufoGreen;
                    }

                    &.canceled {
                        border-top: 5px solid $dullRed;
                    }

                    &.missed {
                        border-top: 5px solid $yellowSea;
                    }

                    &.showedup {
                        border-top: 5px solid $majorelleBlue;
                    }

                    &.attended {
                        border-top: 5px solid $linkWater;
                    }

                    &.online:before {
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        bottom: 0;
                        right: 0;
                        content: '\f57d';
                        font-family: "Font Awesome 5 Pro";
                        font-weight: 400;
                    }

                    &.online-canceled-not-paid:after {
                        width: 20px;
                        height: 20px;
                        position: absolute;
                        bottom: 0;
                        right: 15px;
                        content: '\f4e8';
                        font-family: "Font Awesome 5 Brands";
                        font-weight: 400;
                        color: $dullRed;
                    }
                }

                &.selected {
                  position: absolute;
                  z-index: 1000 !important;

                  &.queue {
                    opacity: 1;
                  }
                }

                &:hover {
                    color: #ffffff;
                    background-color: $pictionBlue;
                    font-weight: bold;
                }
            }

            .fc-bgevent {
                background-image: linear-gradient(-45deg, #ffffff 25%, $dullRed 25%, $dullRed 50%, #ffffff 50%, #ffffff 75%, $dullRed 75%, $dullRed 100%);
                background-size: 22px 22px;
                opacity: 0.1;

                &.non-working-days {
                    background-image: linear-gradient(-45deg, #ffffff 25%, $linkWater 25%, $linkWater 50%, #ffffff 50%, #ffffff 75%, $linkWater 75%, $linkWater 100%);
                    background-size: 22px 22px;
                    opacity: 0.2;
                }
            }

            .fc-unthemed td.fc-today {
                background-color: rgba(33, 167, 240, 0.1);
            }

            .fc-time-grid-event-inset {
                -webkit-box-shadow: 0px 0px 10px 0px rgba(36,167,240,0.4);
                -moz-box-shadow: 0px 0px 10px 0px rgba(36,167,240,0.4);
                box-shadow: 0px 0px 10px 0px rgba(36,167,240,0.4);
            }

            .fc-head-container.fc-widget-header {
                border-color: #ffffff !important;
                position: -webkit-sticky; /* Safari */
                position: sticky;
                top: -1px;
                z-index: 10;

                .fc-day-header.fc-widget-header {
                    border-color: #ffffff !important;
                    border-bottom: 1px solid $athenGray2 !important;
                    border-right: 1px solid $athenGray2 !important;
                    background-color: white;
                }

                .fc-axis {
                    background-color: #ffffff;
                }
            }

            .fc-scroller.fc-time-grid-container {
                overflow: hidden !important;
            }

            .fc-body .fc-widget-content {
                border: 0;

                td {
                    border-left: 1px solid $athenGray2;
                    border-right: 1px solid $athenGray2;
                }

                tr:nth-child(odd) td.fc-widget-content {
                    border-top: 1px solid $athenGray2;
                }
                tr:nth-child(even) td.fc-widget-content {
                    border-top: 1px dashed $athenGray2;
                }

                tr:first-child td.fc-widget-content {
                    border-top: 0;
                }

                tr:last-child td.fc-widget-content {
                    border-bottom: 1px solid $athenGray2;
                }
            }

            .fc-time-grid .fc-content-skeleton {
                td {
                    border: 0 !important;
                }
            }

            .fc-content {
                display: flex;
                flex-flow: column wrap;
                min-height: calc(100% - 5px);
                justify-content: space-between;

                .fc-time {
                    font-size: .6em;
                    flex: 0 1 100%;
                    order: 2;
                    height: fit-content;
                }

                .fc-title {
                    flex: 0 1 100%;
                    order: 1;
                    white-space: nowrap;
                }
            }

            .fc-time-grid {
                .fc-bg {
                    border: 0;
                }
                table {
                    border: 0px solid;
                }

                .fc-slats td {
                    height: 80px !important;
                }
            }

            .fc .fc-axis {
                font-family: 'sf_pro_displayregular';
                border-style: none !important;
                font-size: 0.8em;
                vertical-align: top;
            }
        }
    }

    .printable {
        display: none;
    }

    .repeat-box {
        background-color: $athenGray1;
    }

    #appointment-modal .modal-lg {
      max-width: 900px;

      .telehealth-info {
        font-size: 14px;
      }
    }

    .telehealth-minutes-warning {
      font-size: 14px;
    }

    @media (max-width: 767px) {
        .agenda {
            min-height: calc(100vh - 96px);

            .box-fullcalendar {
                .fc-head-container.fc-widget-header {
                    top: -1px;
                }
            }
        }
    }

    @media print {
        .main-header, .box-fullcalendar {
            display: none;
        }
        #app {
          .container,
          .agenda {
            padding: 0!important;
          }
          .content {
            overflow: visible;
          }
          .home,
          .agenda .d-flex {
            display: block!important;
          }
        }

        .printable {
            display: block;

            .header {
                box-decoration-break: clone;
            }

            .table {
                border: 0;
                display: table;
            }

            thead tr:not(.thead) th {
                border: 0 !important;
            }

            thead tr.thead th {
                background-color: $pictionBlue !important;
                color: #ffffff;
            }

            table { width: 100%; margin-top: 200px; page-break-after:auto; }
            tr    { page-break-inside:avoid; page-break-after:auto; }
            td    { page-break-inside:avoid; page-break-after:auto; }
            thead { display:table-header-group }
            tfoot { display:table-footer-group }

            tbody td {
                vertical-align: middle;
            }
        }
    }
</style>

